const faq = require('./en_faq');
const privacyPolicy = require('./en_privacy_policy');

module.exports = {
   home: 'Home',
   'my-doctor': 'My doctor',
   active: 'Active',
   block: 'Block',
   unblock: 'Unblock',
   documents: 'Documents',
   search: 'Search',
   license: 'License',
   'state-licenses': 'State Licenses',
   'edit-doctor-settings': 'Edit Doctor Settings',
   'licenses': 'Licenses',
   graduation: 'Graduation',
   'doctor-from-another-state-title': 'This doctor is not licensed in your state',
   'doctor-from-another-state-text': 'Please input reason to continue.',
   'doctors-list-placeholder': 'Sorry, no doctors were found by your request',
   'proceed': 'Proceed',
   'confirm-cancel-change-ok-label': 'Yes, I confirm',
   'confirm-cancel-change-cancel-label': 'No',
   'confirm-cancel-change-text': 'You\'re going to cancel chosen membership for the next period. If you current membership is renewable, it will be prolonged for the next period on a given date. Do you confirm canceling future membership?',
   'confirm-cancel-change-title': 'Confirm cancellation',
   'change-subscription-notice': 'If you change a membership with a doctor, your current membership will last till the end of the paid period and after that, a new membership will be activated. You will be charged right before activating a new membership.',
   internship: 'Internship',
   'guest-choose-licensed-doctor': 'After authorization you can only choose a doctor licensed in your state.',
   specialty: 'Specialty',
   membership: 'Membership',
   'back-to-admin': 'Back to Admin',
   language: 'Language',
   service: 'Service',
   welcome: 'Welcome',
   'link-copied': 'The link has been copied to the clipboard',
   'another-card': 'Another card',
   'reset-filters': 'Reset filters',
   'fill-out-form': 'Please fill out the registration form below.',
   settings: 'Settings',
   'back-label': 'Back',
   'done': 'Done',
   'approved': 'Approved',
   'initial': 'Initial',
   'declined': 'Declined',
   delete: 'Delete',
   'share-profile': 'Share profile',
   'share-link': 'Share link',
   filters: 'Filters',
   'confirm-label': 'Confirm',
   'confirm-deletion': 'Confirm deletion',
   'confirm-deletion-patient-first': 'Are you sure you want to delete this record?',
   'confirm-deletion-patient-second': 'All data will be permanently deleted and no longer accessible. Do you confirm it?',
   'add-allergy': 'Add allergy',
   profile: 'Profile',
   queued: 'Queued',
   sending: 'Sending',
   delivered: 'Delivered',
   'resend-document': 'Resend',
   'account-blocked': 'Account is blocked by admin',
   'resend-error': 'An error occurs while trying to resend fax.',
   'error-label': 'Error',
   'error-invalid-positive-numeric-field': 'This field must contain a valid number greater than 0!',
   'error-invalid-blood-pressure': 'Blood pressure must be in the following format: "120/80"!',
   'from-title': 'From',
   'select-doctor': 'Select doctor',
   vma: 'VMA',
   'share-with-patient-label': 'Share with patient',
   'attach-label': 'Attach',
   'select-doctor-for-attach': 'Please select a doctor or VMA to which attach the fax:',
   'enter-doctor-or-vma': 'Enter name or email for search',
   receiving: 'Receiving',
   received: 'Received',
   'no-answer': 'No answer',
   busy: 'Busy',
   failed: 'Failed',
   canceled: 'Canceled',
   file: 'File',
   download: 'Download',
   invalid_expiry_year: 'Invalid expiration date',
   'my-profile': 'My profile',
   'delete-task': 'Delete task',
   'phoneNumber-warn-country-code': `
Please take note that if your phone number is not registered in the US you must include the country code.

All numbers without a country code will be considered US numbers and formatted accordingly.`,
   'fax-empty': 'Please, enter your fax number',
   'imaging-referral-disclaimer':
      '<strong>***NOTE***</strong> This service is for <strong>CASH PAY ONLY</strong> services. <strong style="font-style: underline;">We do not obtain prior authorization from insurance.</strong> Many imaging centers offer cash discounts, which are often less than insurance rates. If you have a high deductible health plan, the cash pay option is ideal. If you desire to run the imaging study through your insurance, we ask that you personally submit the required documentation directly to both the imaging center and your insurance carrier. We cannot guarantee that your insurance will cover the cost of the diagnostic imaging study.<br/>'
      + '<strong>***NO MEDICAID/MED-CAL OR MEDICARE*** We DO NOT provide medical services to persons with MEDICAID or MEDICARE insurance. If you are on MEDICAID or MEDICARE,  you must obtain your imaging orders through your personal physician.<br/>'
      + '***NOTE***WE WILL NOT ORDER MRA\'s or Cardiac MRI\'s***Please DO NOT sign up for an MRI referral if you are evaluating chest pain or heart disease.</strong>',
   'invalid-coupon': 'Coupon code is not valid. ',
   'fax-title': 'Fax title',
   'fax-to': 'To',
   to: 'To',
   from: 'From',
   'progress-percents': 'Progress %s',
   'date-time': 'Date and time',
   'maxlength-homeAddress': 'Home address length must be less than %s',
   'maxlength-workAddress': 'Work address length must be less than %s',
   'maxlength-homeCity': 'Home city length must be less than %s',
   'maxlength-workCity': 'Work city length must be less than %s',
   'maxlength-city': 'City length must be less than %s',
   'maxlength-npiNumberValue': 'Npi number length must be less than %s',
   'maxlength-deaNumberValue': 'Dea number length must be less than %s',
   'maxlength-erxPharmacistMessage': 'Pharmacist message length must be less than %s',
   'maxlength-medication': 'Medication name length must be less than %s',
   'maxlength-instructions': 'Instructions length must be less than %s',
   'maxlength-preferredImagingCenter': 'Preferred imaging center length must be less than %s',
   'wrong-email-format': 'This is not a valid email address.',
   'empty-email': 'Please enter your email address.',
   'invalid-zip': 'Zip code exact must have a five digits',
   'search-by-patient': 'Search by patient name',
   messages: 'Messages',
   applications: 'Applications',
   'apply-label': 'Apply',
   'promocode-label': 'Promo code',
   'new-crop': 'New Crop',
   'promocode-placeholder': 'Type promo code',
   providers: 'Providers',
   patients: 'Patients',
   'total-label': 'Total',
   'discount-label': 'Discount',
   'subtotal-label': 'Subtotal',
   'no-contacts-found': 'No contacts found',
   'no-tasks-found': 'No tasks found',
   'no-notes-yet': 'No notes yet',
   'no-macros-yet': 'No macros yet',
   'no-assistants-yet': 'No assistants yet',
   'no-imagings-yet': 'No imaging orders yet',
   'no-diagnoses-yet': 'No diagnoses yet',
   'no-encounters-yet': 'No encounters yet',
   'add-signature': 'Add signature',
   'add-encounter-label': 'Add encounter',
   'substitution-allowed': 'Substitution allowed',
   open: 'Open',
   closed: 'Closed',
   public: 'Public',
   private: 'Private',

   'bio-short': 'Bio',
   'bio-full': 'Bio',
   'all-short': 'All',
   'all-full': 'Allergies',
   'meds-short': 'Meds',
   'meds-full': 'Medications',
   'notes-short': 'Notes',
   'notes-full': 'Notes',
   'pmh-short': 'PMH',
   'pmh-full': 'Past medical history',
   'psh-short': 'PSH',
   'psh-full': 'Past surgical history',
   'shx-short': 'SHx',
   'shx-full': 'Social history',
   'fhx-short': 'FHx',
   'fhx-full': 'Family history',
   'rxhx-short': 'Rx Hx',
   'rxhx-full': 'Prescriptions',
   'patient-profile': 'Patient profile',

   'details-short': 'Details',
   'details-full': 'Details',
   'diagnosis-short': 'Dx',
   'diagnosis-full': 'Diagnosis',
   'labs-short': 'Lab',
   'labs-full': 'Labs',
   'imaging-short': 'Imaging',
   'imaging-full': 'Imaging orders',
   'prescriptions-short': 'Rx',
   'prescriptions-full': 'Prescriptions',
   'referrals-short': 'Referral',
   'referrals-full': 'Referrals',
   'vitals-short': 'Vitals',
   'vitals-full': 'Vitals',

   'send-encounter-title': 'Send to contact',
   'new-vma': 'New VMA',
   'assignee-empty': 'Please choose an assignee',
   'service-name-label': 'Service name',
   'patient-empty': 'Please choose a patient',
   'description-empty': 'Please type a description',
   'service-price-empty': 'Please, fill a service prices fields',
   'price-empty': 'Please fill in Price field',
   'price-too-low': 'Price value should be more than 0',
   'service-fields-empty': 'Please, choose at least one service field',
   'non-subscribers': 'Non subscribers',
   'empty-imaging': 'Please choose an imaging',
   'vmas-info': 'VMA\'s info',
   'add-imaging': 'Add imaging',
   imagings: 'Imaging orders',
   'confirm-macro-deletion-title': 'Confirm macro deletion',
   'confirm-macro-deletion-text': 'Do you really want to delete macro?',
   'shortcut-empty': 'Please type a shortcut',
   'text-empty': 'Please type a text',
   'create-contact-label': 'Create contact',
   'add-new-label': 'Add new',
   'doctor-label': 'Doctor: ',
   'doctor-plain-label': 'Doctor',
   faxes: 'Faxes',
   sent: 'Sent',
   'creator-label': 'Creator',
   'creator-name': 'Creator name',
   'insurance-copy-label': 'Copy of insurance card ',
   'insurance-card': 'Insurance card ',
   'insurance-copy-note': '(If Applicable. Occasionally required for referrals.)',
   'delete-diagnosis-confirmation-text': 'Do you really want to delete diagnosis?',
   'delete-diagnosis-confirmation-title': 'Confirm diagnosis deletion',
   'delete-problem-confirmation-text': 'Do you really want to delete this problem from the Problem List?',
   'delete-problem-confirmation-title': 'Confirm problem deletion',
   'create-encounter': 'Create encounter',
   'assignee-label': 'Assignee',
   'load-label': 'Upload new',
   'encounter-reason-empty': 'Please, fill encounter reason',
   'delete-encounter-text': 'Are you sure you want to delete this encounter? All information related to this encounter will be lost',
   'closed-label': 'Closed',
   'comment-empty': 'Please, enter comment',
   'allergy-empty': 'Please, select allergy',
   'open-label': 'Open',
   'delete-encounter-title': 'Confirm deletion',
   'created-label': 'Created',
   'task-label': 'Task',
   'category-label': 'Category',
   'note-type': 'Note type',
   'imaging-label': 'Imaging',
   attachments: 'Attachments',
   'no-doctor': 'No doctor',
   contacts: 'Contacts',
   'new-contact': 'New contact',
   'all-users': 'All users',
   'vmas-dropdown-placeholder': 'Choose assignee',
   'patient-doctor-different-state-need-reason': 'Patient and doctor from different state, enter reason',
   'new-task': 'New task',
   by: ' by ',
   notes: 'Notes',
   'description-label': 'Description',
   'assign-task-notification-title': 'New task',
   'assign-task-notification-text': ' has been assigned new task to you.',
   'new-medical-file-notification-title': 'New medical file',
   'new-medical-file-notification-text': ' has been add new medical file to your profile',
   diagnosis: 'Diagnosis',
   imaging: 'Imaging order',
   labs: 'Labs',
   prescriptions: 'Prescriptions',
   'patients-dropdown-placeholder': 'Choose patient',
   'no-results-found': 'No results found',
   'no-referrals-yet': 'No referrals yet',
   'delete-referral-confirmation-title': 'Confirm referral deletion',
   'delete-referral-confirmation-text': 'Do you really want to delete referral?',
   'add-note-label': 'Add note',
   'diagnosis-label': 'Diagnosis',
   'send-to-contact-label': 'Send to contact',
   'choose-note-type': 'Choose note type',
   'type-label': 'Type',
   'empty-field': 'Please fill a "%s" field',
   'create-task-with-fax': 'Create task with fax',
   'add-to-homepage': 'Add to home',
   'remove-from-homepage': 'Remove from home',
   'invalid-field-name': 'Invalid field name',
   'empty-note-type': 'Please, select note type',
   'attach-files': 'Attach files',
   doctors: 'Doctors',
   'visa-label': 'Visa',
   'mastercard-label': 'MasterCard',
   'payment-methods': 'Payment Methods',
   'add-card': 'Add Card',
   'pay': 'Pay',
   'save-card': 'Save Card',
   'note-label': 'Note',
   'i-agree-with': 'I Agree with',
   'applied': 'Applied',
   note: 'note',
   'error-fill-at-least-one-field': 'Please fill at least one of the fields.',
   'format-note-attachment-error': 'The file you are trying to upload has the unsupported format. \n\r'
      + 'Please, select one of the next: pdf, doc, jpg, png, mp4, avi',
   'format-imaging-attachment-error': 'The file you are trying to upload has the unsupported format. \n\r'
      + 'Please, select one of the next: pdf, doc, jpg, png, mp4, avi, rar, 7z, zip, gzip',
   'share-label': 'Share',
   'share-lab-result-label': 'Share Lab Result',
   'document-was-added-title': 'Document was added',
   'document-was-added-text': 'Document %s successfully added to %s',
   'booked-by-me': 'Booked by me',
   'fax-send-failed-title': 'Fax sending failed',
   'fax-failed-notification-body': 'Sending fax to number %s was failed with status %s',
   'attachments-label': 'Attachments',
   'fax-received-title': 'Fax received',
   'fax-received-body': 'You have a new fax from number %s',
   'send-to-chat-with-patient': 'Send to chat with patient',
   'unshare-label': 'Unshare',
   'unshare-lab-result-label': 'Unshare Lab Result',
   'select-vma-title': 'Select VMA',
   'select-doctor-title': 'Select Doctor',
   'share-patient-record-title': 'New record shared',
   'share-patient-lab-result-title': 'New lab result shared',
   'share-patient-record-body': '%jsx shared with you %jsx',
   'share-patient-lab-result-body': 'Dr. %jsx has shared a %jsx result with you',
   'review-for': 'For %jsx',
   'review-by': 'By %jsx',
   'blood-pressure-table-label': 'Blood pressure',
   'select-doctor-label': 'Please select Doctor with which to share a fax:',
   'select-vma-label': 'Please select VMA with which to share a fax:',
   'select-patient-title': 'Select Patient',
   'select-patient-label': 'Please select patient to share a document:',
   'delete-note-confirmation-title': 'Confirm note deletion',
   'delete-note-confirmation-text': 'Do you really want to delete note?',
   'success-label': 'Success',
   'reset-success': 'Password has been reset successfully',
   'how-it-works': 'How it works',
   'plans-and-prices': 'Plans & Prices',
   'our-customers': 'Our customers',
   'ask-now': 'Ask now',
   'our-email': 'support@cirrusmed.com',
   'search-contact': 'Search contact',
   copyright: '© %s CirrusMED, All rights reserved',
   'per-period-consultation': 'per consultation',
   'common-name-empty': 'Please enter name',
   'edit-contact': 'Edit contact',
   'edit-problem-modal-title': 'Edit existing problem',
   'per-period-month': 'monthly',
   'equals-to-month': 'equals to %s/month',
   quarterly: 'quarterly',
   annually: 'annually',
   'city-state-zip': 'City, State, Zip',
   'one-week-access': 'one week access',
   'one-week-consultation': '1 week',
   status: 'Status',
   'confirm-delete-contact-title': 'Confirm contact deletion',
   'reset-vma-password-confirm-title': 'Confirm reset vma password',
   'reset-vma-password-confirm-text': 'Do you really want to reset vma password?',
   'confirm-delete-contact-text': 'Do you really want to delete contact?',
   'monthly-consultation': '1 month',
   '3-month-consultation': '3 months',
   email: 'Email',
   'name-category-label': 'Name / Category',
   '12-month-consultation': '12 months',
   'online-primary-care-physician': 'Online Primary Care Physician',
   '24/7-access': '24/7 Access',
   'unlimited-consultations': 'Unlimited Consultations',
   consultations: 'Consultations',
   'grant-admin-account-notice': 'To make a user an admin, please enter their email and confirm',
   'secure-messaging': 'Secure Messaging',
   'lab-x-ray-orders': 'Lab & X-Ray Orders',
   referrals: 'Referrals',
   'create-admin': 'Create admin',
   'grant-admin-account': 'Grant admin account',
   'heart-rate-label': 'Heart rate',
   'weight-label-lbs': 'Weight (lbs)',
   'lbs-label': 'lbs',
   'height-label-in': 'Height (in)',
   'in-label': 'in',
   'bmi-label': 'Body mass index',
   'temperature-label': 'Temperature',
   'fahrenheit-label': '°F',
   'temperature-f-label': 'Temperature (°F)',
   'respiratory-rate-label': 'Respiratory rate',
   'recorded-by': 'Recorded by',
   'personal-health-record': 'Personal Health Record',
   'video-conferencing': 'Video Conferencing',
   'new-note-type': 'New note type',
   'note-type-name': 'Note type name',
   subjective: 'Subjective',
   objective: 'Objective',
   assessment: 'Assessment',
   plan: 'Plan',
   'field-names-label': 'Field name',
   'empty-fields-name': 'Please add at least one field name',
   'empty-name': 'Please type a name',
   'confirm-note-type-deletion-title': 'Confirm note type deletion',
   'profile-not-filled-label': 'Please complete your Bio and health history under your Profile.',
   'confirm-note-type-deletion-text': 'Are you sure want to delete note type?',
   'phone-invalid': 'Please type a valid phone number',
   'fax-invalid': 'Please type a valid fax number',
   'category-invalid': 'Please choose a correct category',
   'imaging-type-label': 'What type of imaging are you requesting?',
   'body-part-label': 'Which body parts(s) would you like scanned?',
   'laterality-label': 'Laterality:',
   'contrast-label': 'With or Without Contrast?',
   'contrast-allergy-label': 'Contrast or Iodine Allergy?',
   'implants-label': 'Do you have an implantable device?',
   'clinical-history-label': 'Clinical History:',
   'clinical-history-placeholder': 'Please, describe what symptoms you are having and why you are requesting this test?',
   'desired-imaging-center-label': 'Desired Imaging Center:',
   'desired-imaging-center-placeholder': 'Please indicate which imaging center you would like us to send your referral to. Example: "AFFORDABLE SCAN IMAGING, 404 Bryant St Suite 404 San Francisco, CA 94107". At a minimum, please include the facility NAME and ZIP CODE.',
   'documents-label': 'Documents',
   'documents-notice': 'Please upload any pertinent documents such as old medical records, -x-rays, lab results, etc. Use the following file extension: pdf, doc, jpg, png, mp4, avi, rar, 7z, zip, gzip',
   'comments-label': 'Comments:',
   'comments-placeholder': 'Anything else you would like to add?',
   'subscribe-to-system': 'Membership Enrollment',
   subscribers: 'Subscribers',
   'type-of-user': 'Type of user',
   'add-member': 'Add member',
   'consecutive-price': 'Consecutive price',
   'membership-duration': 'Membership duration',
   'request-referral-diagnostic': 'Purchase MRI / Diagnostic Imaging Referral',
   'included-in-membership': 'Included in membership',
   mri: 'MRI',
   'x-ray': 'X-Ray',
   ct: 'CT Scan',
   website: 'Website',
   notification: 'Notification',
   sms: 'SMS',
   ultrasound: 'Ultrasound',
   'head-brain': 'Head/Brain',
   neck: 'Neck (not spine)',
   shoulder: 'Shoulder',
   elbow: 'Elbow',
   wrist: 'Wrist',
   hand: 'Hand',
   'erx-error-title': 'E-Prescribe error',
   chest: 'Chest/Lungs',
   abdomen: 'Abdomen',
   'prescription-instruction-note': 'Original formatting would not be saved on partner system',
   'prescription-pharmacistMessage-note': 'Original formatting would not be saved on partner system',
   pelvis: 'Pelvis',
   'cervical-spine': 'Cervical Spine (Neck)',
   'thoracic-spine': 'Thoracic Spine (Mid-Back)',
   'not-integer-value': 'Value must be an integer',
   'lumbar-spine': 'Lumbar Spine (Low Back)',
   'max-quantity-number': 'Max quantity number is 9999',
   'max-refills-number': 'Max refills number is 99',
   'sacrum-spine': 'Sacrum/Pelvis Spine',
   'hip-joint': 'Hip Joint',
   'knee-joint': 'Knee Joint',
   'ankle-joint': 'Ankle Joint',
   foot: 'Foot',
   right: 'Right',
   left: 'Left',
   biliteral: 'Bilateral (Both Sides)',
   'not-applicable': 'Not Applicable',
   'pharmacy-state': 'Pharmacy state',
   'preferred-pharmacies': 'Preferred pharmacies',
   yes: 'Yes',
   no: 'No',
   notSure: 'Not sure',
   'intake-form': 'Intake form',
   'birthDate-max-invalid': 'Chosen date can not be after actual date',
   'birthDate-min-invalid': 'Chosen date can not be before 1900 year',
   'close-label': 'Close',
   'body-part': 'Body part(s)',
   laterality: 'Laterality',
   contrast: 'Contrast',
   'contrast-allergy': 'Contrast or Iodine Allergy?',
   implants: 'Implantable device',
   'clinical-history': 'Clinical History:',
   'desired-imaging-center': 'Desired Imaging Center:',
   weight: 'Weight (pounds)',
   height: 'Height (inches)',
   comments: 'Comments:',
   'only-month-users-text': 'You should have at least one-month membership to use this feature. Please upgrade you membership.',
   'membership-options': 'Membership options',
   'membership-options-notice': 'To retain an online concierge physician, select one of the following membership options',
   'available-services-notice': 'For one-time requests, please choose one of the following available services',
   'yes-contrast-extended': 'With contrast',
   'no-contrast-extended': 'Without contrast',
   'notSure-contrast-extended': 'Not sure about contrast',
   'save-imaging-request': 'Save imaging request',
   'clinical-history-empty': 'Please enter a clinical history',
   'desired-imaging-center-empty': 'Please enter a desired imaging center',
   plans: 'Plans',
   NOT_A_NUMBER: 'Not a number',
   INVALID_COUNTRY: 'Invalid country',
   TOO_LONG: 'The phone number is too long',
   services: 'Services',
   'imaging-referral-service-name': 'MRI / Imaging Referral (+30 Days access to platform)',
   'imaging-referral-service-description': 'Physician Referral for Diagnostic Imaging'
      + '<ul>'
      + '<li> One physician referral (doctor\'s order/prescription) sent to an imaging center of your choice. </li>'
      + '<li> Additional referrals (up to 3) subject to additional fees.</li>'
      + '<li> Please allow at least 2 business days to submit the referral. </li>'
      + '<li> Additional time may be required, depending on the complexity of the request.</li>'
      + '<li> One month of CirrusMED membership included </li>'
      + '<li> NOTE: We do not process prior authorizations, often required by insurers. This is a "cash-only" service. </li>'
      + '</ul>'
      + 'Please see the list of radiology procedures that can be ordered by your <br/>CirrusMED physician <a href="https://cirrusmedicalnetwork.com/diagnostic-imaging-list/" target="_blank">here</a>',
   'buy-label': 'Buy',
   sign: 'Signature',
   'upload-new': 'Upload new',
   'signature-oversized': 'The file you are trying to upload is too big. Maximum file size is 20 Mb',
   'signature-not-supported-type': 'Please, select one of the next: jpg, png',
   'signature-notice': 'The signature will be used for documents you are going to send to contacts and patients.',
   'confirm-sending-title': 'Confirm action',
   'confirm-sending-text': 'Signature has not been added. Would you like to send document anyway?',

   'imaging-referral-cost': 'Imaging referral (+1 month access to the platform) / $59',
   'additional-imaging-request-cost': 'Additional imaging request / $30',
   total: 'Total: ',
   'pay-for-service': 'Pay for service',
   'imaging-referral': 'MRI / Imaging Referral',
   'add-order': 'Add order',
   'e-prescribe': 'ePrescribe',
   'patient-information': 'Patient Information',
   'patient-sign-up-label': 'Patient Sign Up',
   'doctor-sign-up-label': 'Doctor Sign Up',
   lab: 'Lab',
   'imaging-center': 'Imaging Center',
   'imaging_center': 'Imaging Center',
   hospital: 'Hospital',
   other: 'Other',
   provider: 'Provider',
   'i-am-patient': 'I Am Patient',
   'i-am-doctor': 'I Am Doctor',
   'sign-up': 'Sign Up',
   referring: 'Referring',
   'login-label': 'Login',
   'residency': 'Residency',
   'sign-up-common-title': 'Sign Up',
   'sign-up-doctor-title': 'Sign Up as Doctor',
   'sign-up-patient-title': 'Sign Up as Patient',
   'phone-label': 'Phone',
   'for-one-time-requests': 'For one-time requests',
   'to-retain-concierge': 'To retain an online concierge physician',
   assistants: 'Doctor Assistants',
   'home-phone-label': 'Home/Alternate Phone',
   'homepage-display-label': 'Homepage Display?',
   'erx-errors-notice': 'An error occurs when trying to login eRx system. Make sure you do not use special symbols in following strings:',
   'add-imaging-request': 'Add imaging request',
   'add-additional-imaging-request': 'Add additional request',
   'go-back-label': 'Go back',
   'erx-fill-profile-title': 'Please, fill profile',
   'prescription-history': 'Prescription history',
   'view-encounter': 'View in encounter',
   'erx-fill-profile-text': 'Make sure necessary for ePrescribe fields is filled for doctor/patient - first name, last name, phone number, fax number, home address, work address, work city, work state, work zip, dea number, npi number',
   'fax-label': 'Fax',
   'primary-address-label': 'Address 1',
   'secondary-address-label': 'Address 2',
   'address-label': 'Address',
   'city-label': 'City',
   'state-label': 'State',
   'zip-label': 'Zip',
   'newMessage-notification-type': 'New message',
   'newConsultation-notification-type': 'New consultation',
   'not-subscribers-only-text': 'Only not subscribers can use this service',
   'incoming-document-notification-title': 'New document',
   'new-patient-notification-title': 'New patient',
   'new-patient-notification-body-vma': 'Doctor %s has a new patient ',
   'new-patient-notification-body-doctor': 'You have a new patient ',
   'incoming-document-notification-body': 'New document from %s',
   'cancelConsultation-notification-type': 'Cancel consultation',
   'newPatient-notification-type': 'New patient',
   'upcomingConsultation-notification-type': 'Upcoming consultation',
   'notification-settings-updated-success-text': 'Notification settings updated successfully',
   'current-phone-label': 'Current phone number',
   'current-phone-note': 'If you want to receive SMS notifications, please add your phone number.',
   'current-phone-is-verified': 'Your phone number is verified. If you change it, you will need to verify the new one.',
   'current-phone-cant-verify':
      `Seems like we can't verify your phone number at this moment. Possible causes:
    - The verification service is down.
    - You have requested too many codes for this number and didn't verify any of those codes.
If this keeps happening to you, please, contact support.`,
   'change-email-new-email-label': 'New email: ',
   'change-email-change-label': 'Change',
   'change-email-modal-message':
      `We need to verify that you are the owner of this account, and thus you will receive a verification code via SMS.
Please enter it in the respective field below, along with a new email address.`,
   'change-email-modal-title': 'Change email',
   'change-email-cant-verify':
      `Seems like we can't send you a code via SMS right now. You can't change email without that code.
Possible causes:
    - The verification service is down.
    - You have requested too many codes for this number and didn't verify any of those codes.
If this keeps happening to you, please, contact support.`,
   'change-email-close-modal-title': 'Are you sure?',
   'change-email-close-modal-message': 'We\'ve already sent you a confirmation code. '
      + 'Are you sure you want to stop the process of changing your email?',
   'notification-settings-updated-success-title': 'Success',
   'newServiceRequest-notification-type': 'New service request',
   'newTask-notification-type': 'New task',
   'newFax-notification-type': 'New fax',
   'faxFailed-notification-type': 'Fax failed',
   'sharedNote-notification-type': 'Shared note',
   'sharedLab-notification-type': 'Shared lab',
   'sharedImaging-notification-type': 'Shared imaging order',
   'newMedicalFile-notification-type': 'New medical file',
   'prescriptions-label': 'Prescriptions',
   'add-prescription': 'Add prescription',
   'empty-medication': 'Please choose a medication',
   'empty-instructions': 'Please type an instructions',
   'empty-unit': 'Please choose a unit',
   'less-than-zero-quantity': 'Quantity must be a greater than zero',
   'less-than-zero-days': 'Days must be a greater than zero',
   'confirm-task-creation': 'Confirm task creation',
   'patient-not-selected-warning': 'Patient\'s name is not selected. Continue anyway?',
   'negative-refills': 'Refills must be a positive',
   'select-service-placeholder': 'Select service',
   'select-plan': 'Select membership plan',
   'no-note-types-yet': 'No note types yet',
   'maxlength-firstName': 'First name length must be a less than 35 symbols',
   'maxlength-lastName': 'Last name length must be a less than 35 symbols',
   'attachment-deletion-confirm-title': 'Confirm result deletion',
   'attachment-deletion-confirm-text': 'Do you really want to delete result?',
   doctor: 'Doctor',
   patient: 'Patient',
   'email-label': 'Email *',
   'email-plain-label': 'Email',
   'instructions-label': 'Instructions',
   'quantity-label': 'Quantity',
   'unit-label': 'Unit',
   'medication-label': 'Medication',
   'days-label': 'Days',
   'refills-label': 'Refills',
   'email-placeholder': 'Your email',
   'password-placeholder': 'At least 6 symbols',
   'password-label': 'Password *',
   'password-login-placeholder': 'Your password',
   'confirm-password-label': 'Repeat Password*',
   'confirm-password-placeholder': 'Type password again',
   'next-label': 'Next',
   medicalhistory: 'Medical history',
   surgicalhistory: 'Surgical history',
   'subscriptionExpireAt-label': 'Membership expires at',
   'next-step-label': 'Next Step',
   'save-continue-label': 'Save and Continue Later',
   'already-account': 'Already have an account?',
   'not-account': 'Don\'t have an account?',
   'firstName-label': 'First Name *',
   'firstName-placeholder': 'Your first name',
   'lastName-label': 'Last Name *',
   'lastName-placeholder': 'Your last name',
   medication: 'Medication',
   'gender-label': 'Gender *',
   'gender-plain-label': 'Gender',
   'gender-placeholder': 'Choose',
   'zip-invalid': 'Invalid zip code',
   'gender-empty': 'Please choose gender',
   'firstName-empty': 'Please type a first name',
   'phoneNumber-empty': 'Please type phone number',
   'phoneNumber-invalid': 'Invalid phone number',
   'lastName-empty': 'Please type a last name',
   'dob-empty': 'Please choose a birth date',
   'birthDate-label': 'Date of Birth *',
   'for': 'For',
   'every': 'Every',
   'birthDate-placeholder': 'MM-DD-YYYY',
   'specialization-label': 'Specialty *',
   'doctor-empty': 'Please, choose doctor',
   'connect-google': 'Connect google',
   'choose-doctor-dialog-title': 'Choose doctor',
   'choose-doctor-dialog-label': 'Please, choose new patient doctor',
   'specialization-placeholder': 'Your specialty',
   'no-prescriptions-yet': 'No prescriptions yet',
   'education-label': 'Medical School *',
   'confirm-disable-membership-title': 'Confirm action',
   'confirm-disable-membership-text': 'Please note that your patients who already purchased this membership will stay on it.',
   'medical-school-label': 'Medical School',
   'birthDate-empty': 'Please, fill a birth date',
   'medical-files': 'Medical files',
   'years-old': ' y. o.',
   'education-placeholder': 'Your medical school',
   'graduation-label': 'Degree *',
   'graduation-placeholder': 'Choose',
   'graduationAdditional-label': 'Other',
   'graduationAdditional-placeholder': 'PharmD, PHD, MBA, MS, etc.',
   'certification-label': 'Board Certification',
   'certification-placeholder': 'Your board certification',
   'empty-diagnosis': 'Please choose a diagnosis',
   'empty-diagnosis-note': 'Please type a note',
   'phoneNumber-label': 'Phone - Cell/Mobile *',
   'phoneNumber-plain-label': 'Phone - Cell/Mobile',
   'phoneNumber-placeholder': 'Your phone - Cell/Mobile',
   'bio-label': 'Personal Statement',
   'residency-label': 'Residency/Internship *',
   'residency-placeholder': 'Residency',
   results: 'Results',
   'training-label': 'Additional Training/Expertise',
   'training-placeholder': '',
   'graduationYear-label': 'Year of Graduation of Medical School',
   'graduationYear-plain-label': 'Year of Graduation',
   'graduationYear-placeholder': 'YYYY',
   bio: 'Bio',
   'bio-placeholder': 'Tell about yourself',
   'add-patient': 'Add patient',
   'add-diagnosis': 'Add diagnosis',
   'add-referral': 'Add referral',
   'license-label': 'State License(s) *',
   'show-more': 'Show more',
   'drag-drop-notice': 'Drag & Drop File Here to upload or click - ',
   'save-results-label': 'Save results',
   'license-plain-label': 'State License(s)',
   'create-task-label': 'Create task',
   'pharmacy-label': 'Pharmacy',
   'license-placeholder': 'Choose',
   'medication-empty': 'Please, choose medication',
   'choose-membership': 'Choose Membership',
   'getting-started-label': 'Get Started',
   'you-will-get': 'You will get',
   'delete-imaging-confirmation-title': 'Confirm imaging order deletion',
   'delete-imaging-confirmation-text': 'Do you really want to delete imaging order?',
   'imaging-deletion-title': 'Imaging order deleted',
   'imaging-deletion-body': '%s %s has deleted an order for imaging - %s',
   'language-label': 'Language *',
   'if-you-have-membership': 'if you have membership',
   'active-diagnosis': 'Active diagnosis',
   'add-to-problem-list': 'Add to Problem List/Update in Problem List',
   'problem-list-add-or-update': 'Add/Update existing',
   'problem-list-update': 'Update problem',
   'problem-list-empty': 'No problems found',
   'start-field-more-than-end': 'Left field value must be less than right',
   'cirrus-medical-network': 'Cirrus Medical Network',
   'language-plain-label': 'Language',
   'language-placeholder': 'Choose',
   'age-information': 'Age Information',
   'data-security': 'Data Security',
   and: 'And',
   or: 'Or',
   'include-patients-doctors-in-report': 'Include patients doctors in report',
   'sign-up-label': 'Sign Up',
   disclaimer: 'By signing up, you agree to our <a href="/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>.',
   all: 'All',
   male: 'Male',
   female: 'Female',
   'current-subscription-status': 'Current membership status',
   'patients-doctor-information': 'Patient\'s doctor information',
   'search-by-documents': 'Search by fax number or fax title',
   'search-by-name': 'Search by name',
   'edit-encounter-title': 'Edit encounter',
   'view-profile': 'View profile',
   encounters: 'Encounters',
   'add-encounter': 'Add encounter',
   tasks: 'Tasks',
   choose: 'Choose',
   'unique-email': 'This email address is already occupied.',
   'forgot-password-label': 'Forgot password?',
   'credentials-mismatch': 'Email or password are mismatch',
   'account-not-activated': 'Please activate you account',
   'account-banned': 'Your account were disabled by support',
   'edit-task': 'Edit task',
   'logout-label': 'Logout',
   avatar: 'Profile photo',
   'vmas-label': 'Doctor assistants',
   name: 'Name',
   'active-patients': 'Active patients',
   rate: 'Rate',
   actions: 'Actions',
   created: 'Registration date',
   'view-doctor-label': 'View',
   'all-label': 'All',
   'assigned-to-me': 'Assigned to me',
   'view-patient-label': 'View',
   'patient-label': 'Patient',
   'applications-not-found': 'No new applications',
   'providers-not-found': 'Providers are not found',
   'prescriptions-not-found': 'The list of prescriptions is empty',
   'close-task': 'Close task',
   'not-found': 'Not found',
   'search-patients-admin-placeholder': 'Search by patient name or email',
   'search-patients-doctor-placeholder': 'Search by patient name or email',
   'preferred-imaging-center': 'Preferred Imaging Center',
   'preferred-imaging-center-note': 'Include name, address, phone and fax if known.',
   'approve-label': 'Approve',
   'approve-application-commission-label': 'Commission (%)',
   'commission-validation-error': 'Commission must be an integer between 0 and 100!',
   'decline-label': 'Decline',
   'accept-label': 'Accept',
   'reschedule-label': 'Reschedule',
   'cancel-label': 'Cancel',
   'later-label': 'Later',
   'consulting-physician': 'Consulting physician',
   'approve-confirm-title': 'Approve application',
   'detach-vma-confirm-title': 'Delete VMA',
   'detach-vma-confirm-text': 'Are you sure to delete VMA?',
   'detach-vma-label': 'Delete',
   'decline-confirm-title': 'Decline application',
   'decline-confirm-text': 'Are you sure to decline this application?',
   'no-items-yet': 'No items yet',
   'no-labs-yet': 'No labs yet',
   'decline-reason-label': 'Reason',
   'decline-reason-placeholder': 'Type a reason for the refusal',
   'block-label': 'Block user',
   'unblock-label': 'Unblock user',
   'block-confirm-text': 'Are you sure to block this user?',
   'unblock-confirm-text': 'Are you sure to unblock this user?',
   'timezone-label': 'Timezone *',
   'timezone-placeholder': 'Choose',
   'deaNumber-empty': 'Please, type your dea number',
   'npiNumber-empty': 'Please, type your npi number',
   'deaNumber-invalid': 'Please, type correct dea number',
   'npiNumber-invalid': 'Please, type correct npi number',
   'homePhone-label': 'Phone - Home/Other',
   'homePhone-placeholder': 'Your phone - Home/Other',
   'faxNumber-label': 'Phone - Fax *',
   'faxNumber-placeholder': 'Your fax number',
   'faxNumber-empty': 'Please, type a fax number',
   'homeAddress-label': 'Home address 1',
   'homeAddress-empty': 'Please, enter a home address',
   'faxNumber-invalid': 'Please, type a valid fax number',
   'state-empty': 'Please, choose a state',
   'allergies-social-family-history': 'Allergies, Social and Family History',
   'homeAddress-plain-label': 'Home address',
   'homeCity-label': 'Home city',
   'city-empty': 'Please, enter your city',
   'zip-empty': 'Please, enter your zip',
   'workCity-label': 'Work city',
   'homeState-label': 'Home state',
   'workState-label': 'Work state',
   'homeZip-label': 'Home zip',
   'workZip-label': 'Work zip',
   homeCity: 'Home city',
   workCity: 'Work city',
   homeState: 'Home state',
   workState: 'Work state',
   homeZip: 'Home zip',
   workZip: 'Work zip',
   'homeCity-placeholder': 'Your home city',
   'workCity-placeholder': 'Your work city',
   'homeState-placeholder': 'Your home state',
   'workState-placeholder': 'Your work state',
   'homeZip-placeholder': 'Your home zip',
   'workZip-placeholder': 'Your work zip',
   'organizationName-placeholder': 'Your organization name',
   'delete-lab-confirmation-title': 'Confirm lab deletion',
   'delete-lab-confirmation-text': 'Do you really want to delete the lab?',
   'secondaryHomeAddress-label': 'Home address 2',
   'homeAddress-placeholder': 'Your home address 1',
   languages: 'Languages',
   address: 'Address',
   'accept-terms': 'I accept terms ',
   'acknowledge-privacy': 'I acknowledge the Privacy Policy ',
   'acknowledge-prescription-policy': 'I acknowledge the Prescription Policy ',
   'click-to-view-terms': 'click here to view terms',
   'click-to-view-policy': 'click here to view Privacy Policy',
   'click-to-view-prescription-policy': 'click here to view Prescription Policy',
   'accept-privacy-invalid': 'Please acknowledge with Privacy Policy',
   'accept-terms-invalid': 'Please accept Terms',
   'accept-prescription-policy-invalid': 'Please acknowledge with Prescription Policy',
   'homeAddress-plain-placeholder': 'Your home address',
   'secondaryHomeAddress-placeholder': 'Your home address 2',
   'workAddress-label': 'Work address',
   'workAddress-placeholder': 'Your work address',
   'yes-label': 'Yes',
   'no-label': 'No',
   'not-sure-label': 'Not sure',
   'npi-number-label': 'Do you have an NPI Number? *',
   'npi-number-value-label': 'NPI Number *',
   'npi-number-value-placeholder': 'Your NPI number',
   'npi-number-plain-label': 'NPI Number',
   'dea-number-label': 'Do you have a DEA Number? *',
   'dea-number-plain-label': 'DEA Number',
   'dea-number-value-label': 'DEA Number *',
   'dea-number-value-placeholder': 'Your DEA number',
   'signature-label': 'Signature *',
   'connect-dialog-logout-notice': 'This step can\'t be skipped. If you want to come back later you may ',
   'inactive-dialog-notice': 'You Stripe account should be approved, you may come back later',
   'signature-text': 'I confirm that the information given in this form is true, complete and accurate.',
   'document-type-label': 'Please provide your documents',
   'document-type-placeholder': 'Copies of your medical credentials',
   'log-out': 'Log out',
   cv: 'Copy of CV',
   'cv-plain-label': 'Copy of CV',
   medicalDiploma: 'Copy of Medical School Diploma',
   residencyDiploma: 'Copy of Residency Diploma',
   pharmacyCertificate: 'Copy of State Pharmacy Certificate',
   stateMedicalLicences: 'Copy of State Medical License(s)',
   'document-note': 'For verification purposes, please upload copies of your medical credentials below\n'
      + 'using one of the following formats: jpg, png, gif or PDF. These may be uploaded in the\n'
      + 'future if you do not have them available at this time. ',
   'document-short-note': 'For verification purposes, please upload copies of your medical credentials below\n'
      + 'using one of the following formats: jpg, png, gif or PDF.',
   'upload-label': 'Upload',
   'no-chosen-document-type': 'Firstly, select type of uploading document',
   'medical-credentials-label': 'Medical credentials',
   'forgot-password-dialog-header': 'Restore password',
   'to-label': 'Send',
   'create-label': 'Create',
   'verify-label': 'Verify',
   'verify-phone-modal-title': 'Verify your phone',
   'phone-verification-invalid-code': 'Invalid verification code',
   'phone-verification-code-label': 'Verification code:',
   'phone-verification-modal-message': 'We\'ve sent you a message with a six-digit code on this phone number: %s. \n'
      + 'Please enter your code in the field below.',
   'phone-verification-close-modal-message': 'Are you sure you want to stop the phone verification process? '
      + 'The code was already sent to you. If you didn\'t receive it, please try again or contact support.',
   'phone-verification-close-modal-title': 'Stop verification process?',
   'email-not-found': 'User with this email was not registered',
   'restore-password-dialog-header': 'Create new password',
   'create-vma-password-dialog-header': 'Create new password',
   'new-password-label': 'New password *',
   'confirm-new-password-label': 'Repeat new password *',
   'book-consultation': 'Book a consultation',
   'confirm-new-password-placeholder': 'Type password again',
   'save-label': 'Save',
   'reset-token-not-found': 'Reset token is invalid. Please, request a new.',
   'invite-token-not-found': 'Invite token is invalid. Please, request a new.',
   'password-plain-label': 'Password',
   'last-update': 'Last update less than',
   ago: 'ago',
   'edit-label': 'Edit',
   'bio-section': 'Bio',
   'education-section': 'Education and specialty',
   'specialities': 'Specialities',
   'private-section': 'Contact information',
   'documents-section': 'Medical credentials',
   allergies: 'Allergies',
   'allergies-medications-medical-history': 'Allergies, Medications, Past Medical History',
   'diagnostic-imaging-list': 'Diagnostic Imaging list',
   'surgical-family-social-history': 'Past Surgical History, Family History, Social History',
   medications: 'Reported medications',
   pastmedicalhistory: 'Past Medical History',
   pastsurgicalhistory: 'Past Surgical History',
   socialhistory: 'Social History',
   familyhistory: 'Family History',
   'encounter-reason': 'Encounter reason',
   'encounterDetails-field-selector-label': 'Encounter details',
   'reset-password-label': 'Reset password',
   'max-file-size-error': 'Max file size is 20 Mb',
   'invalid-insurance-copy-format': 'The file you are trying to upload has the unsupported format. Please, select one of the next: .pdf, .jpg, .gif, .png.',
   'upload-insurance-label': 'Please upload copy of your medical insurance using one of the following formats: jpg, png, gif or PDF.',

   'private-settings-title': 'Not for public',

   'load-more': 'Load more',
   'choose-doctor': 'Choose your doctor',
   'choose-state': 'Choose state',
   next: 'Next',
   'all-value-label': 'All',
   'license-search-placeholder': 'License',
   'no-doctors': 'No doctors',
   'no-doctors-note': 'Please choose another parameters',
   'no-patients': 'No patients',
   'no-patients-note': 'Please choose another parameters',
   'sort-by': 'Sort by ',
   'video-label': 'Video',
   'chat-label': 'Chat',
   'async-label': 'Asynchronous',
   'other-label': 'Other',
   'choose-type-label': 'Choose type',
   'date-empty': 'Please choose date',
   'time-empty': 'Please choose time',
   'type-empty': 'Please choose type',
   'reason-empty': 'Please type reason',
   'health-changes-empty': 'Please fill a health changes field',
   'illness-history-empty': 'Please fill an illness history field',
   'blood-pulse-invalid': 'Please type a valid blood pulse',
   'blood-pressure-invalid': 'Please type a valid blood pressure',
   'date-invalid': 'Please type correct date',
   'time-invalid': 'Please type correct time',
   'type-invalid': 'Please choose correct type',
   'intake-not-filled': 'Intake not filled',
   'error-empty-requests-title': 'Requests empty',
   'error-empty-requests-text': 'Please add at least one imaging request',
   'confirm-exit-referral-title': 'Confirm exit',
   'confirm-exit-referral-text': 'Are you really want to exit? Data won\'t be saved if you don\'t complete the form.',

   'reason-of-consultation-label': 'What is the reason for consultation?',
   'health-changes-label': 'Any changes in your health since last visit?',
   'intake-weight-label': 'What is your most recent weight (pounds)?',
   'intake-height-label': 'What is your height (inches)?',
   chat: 'Chat',
   'reason-for-visit': 'Reason for visit',
   'blood-pressure-label': 'Most recent blood pressure?',
   'blood-pulse-label': 'Most recent heart rate?',
   'blood-pulse-hint': 'To measure your pulse, count the number of heartbeats in 6 seconds and multiply by 10.',
   'patient-intake-form': 'Patient\'s intake form',
   'illness-history-label': 'History of present illness? What medical concerns would you like addressed?',
   'encounter-datetime': 'Encounter Date and Time',
   'one-week-notice': 'You are about to sign-up for a one-week membership. This purchase includes a  one-time consultation with a physician, including a one-time prescription request. NOTE: MRI/ Imaging referrals are NOT included in the 1-week membership. See \'Available Services\' for MRI/Imaging requests.',
   'subscription-notice': 'You are about to sign-up for a recurring membership. This purchase includes unlimited online primary care services. NOTE: One-time MRI/ Imaging referrals are NOT included. See \'Available Services\' for MRI/Imaging requests.',
   notice: 'Notice',
   'send-cover-page': 'Send cover page',

   'erx-status': 'Erx status',
   'erx-substatus': 'Erx Sub Status',
   'erx-archived-status': 'Archived',

   'edit-availability-label': 'Edit availability',
   'edit-availability-header': 'Edit availability',
   'reschedule-consultation': 'Reschedule consultation',
   'edit-availability-subHeader': 'Choose availability time',
   'max-height': 'Max height value is %s',
   'max-weight': 'Max weight value is %s',
   'requested-status-label': 'Requested',
   'canceled-status-label': 'Canceled',
   'finished-status-label': 'Closed',
   'upcoming-status-label': 'Upcoming',
   'declined-status-label': 'Declined',
   'all-tab-label': 'All',
   'default': 'Default',
   'requests-tab-label': 'Requests',
   'upcoming-tab-label': 'Upcoming',
   'past-tab-label': 'Past',
   'from-date-empty': 'Please, select "from" date',
   'to-date-empty': 'Please, select "to" date',

   'all-free-slots': 'All slots are available',
   'own-slots': 'Your consultations',
   'some-slots': 'Some slots are available',
   'no-available-slots': 'No available slots',

   calendar: 'Calendar',
   'back-to-doctors': 'Back to doctors',

   'next-consultation': 'Next appointment:',
   'not-scheduled': 'Not scheduled',
   'enter-label': 'Enter',
   'next-payment': 'Next Payment',
   'your-doctors': 'Your doctors',

   'suitable-state-label': 'Suitable state',
   'unsuitable-state-reason-label': 'Patient note',

   'change-label': 'Change',

   'contact-us-name': 'Your name',
   'contact-us-email': 'Your email',
   'contact-us-message': 'Your message',
   'thank-you': 'Thank you!',
   'go-to-profile': 'Go to profile',
   'successfully-registered': 'You have been successfully registered.',
   'check-email-and-confirm': 'To activate your account please check your email and confirm the registration.',
   'send-approve-email': 'We\'ll send you an email as soon as your application is approved.',
   'fill-profile-while-review': 'You can fill in your profile while we are reviewing your application.',
   'contact-us-successSubtitle': 'We have received your message and will be in touch shortly.',
   'contact-us-subtitle': 'Feel free to send us any questions.',

   about: 'About',
   'terms-and-conditions': 'Terms and Conditions',
   FAQ: 'FAQ',
   'contact-us': 'Contact us',
   'contact-Us': 'Contact Us',
   blog: 'Blog',

   'upcoming-meetings': 'Upcoming meetings',
   old: 'old',
   'no-upcoming': 'No upcoming consultations',
   'start-now-label': 'Start now',
   'start-label': 'Start',
   'buy-subscription': 'Buy membership',
   'analytics-report': 'Analytics Report',

   'current-password-label': 'Current password',
   'update-old-password': 'New password',
   'repeat-new-password': 'Repeat new password',
   'current-pass-error': 'Current password is incorrect',

   'view-full-profile-label': 'View full profile',
   'view-medical-files': 'Documents',
   'view-invoice': 'View Invoice',
   'not-filled': 'Not filled',
   insurance: 'Insurance ',
   'insurance-note': '(Optional. NOTE: We do not bill insurance.)',
   pharmacy: 'Preferred Pharmacy',
   'birthday-shot-label': 'DOB',
   tel: 'Tel',

   'cancel-meeting-label': 'Cancel meeting',
   'cancel-consultation-title': 'Please tell us the reason',
   'reason-label': 'Reason',
   'input-to-continue': 'Input to continue',
   'reason-placeholder': 'Please type your reason',
   'join-video-chat-label': 'Join Video Chat',

   'no-messages-yet': 'No messages yet',
   'no-chosen-chat': 'Choose a dialog from the list to start chatting.',
   'no-chat-history': 'Your chat messages and history will be displayed here.',
   online: 'Online',
   offline: 'Offline',
   'choose-day': 'Daily',
   'choose-week': 'Weekly',
   'contact-doctor': 'Contact the doctor or look online appointment:',
   'choose-month': 'Monthly',
   'choose-year': 'Yearly',
   'choose-custom': 'Custom',
   'plural-day': 'Days',
   'plural-week': 'Weeks',
   'plural-month': 'Months',
   'plural-year': 'Years',
   'billing-interval': 'Billing interval',
   'membership-name-label': 'Membership name',
   'changes-has-been-saved': 'The changes have been saved!',
   'lasts-till': 'Lasts till',
   'yes-cancel': 'Yes, cancel',
   'no-thanks': 'No, thanks',
   'purchase-label': 'Purchase',
   'active-from': 'Active from',
   'services-placeholder-header': 'No services',
   'services-placeholder-subheader': 'Doctor doesn\'t provide services at the moment',
   'memberships-placeholder-header': 'No memberships',
   'memberships-placeholder-subheader': 'Doctor doesn\'t provide memberships at the moment',
   'cancelled-membership-info-profile': 'The membership ends on ',
   'pay-with-another-card': 'To pay with another card, add it in',
   'address-label-required': 'Address*',
   'city-label-required': 'City*',
   'state-label-required': 'State*',
   'zip-label-required': 'Zip*',
   'membership-info-profile-begin': 'You have ',
   'membership-info-profile-end': ' so you can contact the doctor or book online appointment.',
   'membership-for-service-info-profile-begin': 'You have %s %s membership because you purchased ',
   'membership-for-service-info-profile-end': ' so you can contact the doctor or book online appointment. The membership ends on',
   'not-renewable-membership-info-profile-begin': 'You have ',
   'not-renewable-membership-info-profile-end': ' so you can contact the doctor or book online appointment. The membership ends on ',
   'no-membership-info-profile': 'To book an appointment with this doctor, you should purchase a membership or service that provides membership.',
   'confirm-subscription-cancel-title': 'Confirm Cancellation',
   'confirm-subscription-cancel-text': 'Notice: If you cancel a membership with a doctor, it will last till the end of the paid period. If you change your mind after cancelling, you will be able to take the same or another membership by clicking “Change”. Do you confirm cancelling membership?',
   'invalid-price': 'Invalid price',
   'auto-renewable': 'Auto renewable',
   'membership-name-empty': 'Please, type a membership name',
   'interval-invalid': 'Please, choose a correct interval',
   'invalid-interval_count': 'Interval count must be an positive',
   'invalid-trial_period_days': 'Trial period days count must be a positive or zero value',
   'invalid-description-length': 'Description is too long',
   'price-label': 'Price',
   'payment-methods-placeholder': 'You haven\'t added a credit card yet.',
   'active-now': 'Active Now',
   'organizationName-label': 'Organization Name',
   week: 'week',
   day: 'day',
   year: 'year',
   'send-label': 'Send',
   'select-date-and-time': 'Select date and time',
   'add-chat-member-title': 'Select user',
   'add-chat-member-label': 'Add member to chat',
   'remove-chat-member-title': 'Select user',
   'remove-chat-member-label': 'Remove member from chat',
   add: 'Add',
   time: 'Time',
   remove: 'Remove',
   'trial-label': 'Trial period',
   'send-message-placeholder': 'Your message...',
   'send-message': 'Send message',
   'remove-member': 'Remove member',
   'max-attachment-amount-error': 'You cannot select more than 10 files at one time',
   'format-attachment-error': 'The file you are trying to upload has the unsupported format. \n\r'
      + 'Please, select one of the next: .pdf, .doc, .docx, .xls, .xlsx, jpg, .png, .txt.',
   'size-attachment-error': 'The file you are trying to upload is too big. Maximum file size is 60 Mb',
   'size-note-attachment-error': 'The file you are trying to upload is too big. Maximum file size is 20 Mb',
   'email-dropdown-label': 'Email',
   'fax-dropdown-label': 'Fax',
   daily: 'daily',
   monthly: 'monthly',
   weekly: 'weekly',
   'save-as-draft': 'Save as draft',
   'equals-to': 'equals to',
   month: 'month',
   'isDraft-label': 'Draft prescription',
   'erxstatus-0': 'Not Transmitted',
   'erxstatus-1': 'Print',
   'erxstatus-2': 'Fax',
   'erxstatus-3': 'Electronic/Surescripts Retail',
   'erxstatus-4': 'Electronic/Surescripts Mail Order',
   'erxstatus-5': 'Test',
   'erxsubstatus-S': 'Standard Rx',
   'erxsubstatus-P': 'Renewal Request',
   'erxsubstatus-D': 'DrugSet source',
   'erxsubstatus-O': 'Outside Prescription',
   'erxarchivedstatus-N': 'Current',
   'erxarchivedstatus-Y': 'Discontinued',
   'erxarchivedstatus-C': 'Canceled',

   'pharmacistMessage-label': 'Pharmacist message',
   'send-to-pharmacy': 'Send to patient',
   'active-status-label': 'Current',
   'inactive-status-label': 'Discontinued',
   'cancelled-status-label': 'Cancelled',
   'all-status-label': 'All',
   'middleName-label': 'Middle name',
   'middleName-placeholder': 'Your middle name',
   'changes-saved': 'The changes were successfully saved',

   'add-label': 'Add',
   'allergy-placeholder': 'Allergy',
   'allergy-name-placeholder': 'Name',
   'type-of-reaction-placeholder': 'Type of Reaction',
   'comment-empty-error': 'Please fill a comment field',
   'comment-placeholder': 'Comment',
   'add-a-comment-placeholder': 'Add a comment',
   'membership-name': 'Membership name',
   inactive: 'Inactive',
   activate: 'Activate',
   'new-service-request-title': 'New service request from %s',
   'new-service-request-body': ' requested %s',
   'no-doctors-yet': 'No doctors yet',
   deactivate: 'Deactivate',
   'encounter-details': 'Encounter details',
   'encounterDatetime-label': 'Encounter datetime',
   'new-label': 'new',
   'new-consultation': 'Book appointment',
   'review-list-placeholder': 'No reviews yet',
   'available-services': 'Available services',
   'for-subscribers-only': 'For subscribers only',
   'for-not-subscribers-only': 'For non subscribers only',
   'not-sent': 'Not sent',

   price: 'Price',
   'common-price': 'All users',
   'subscribers-price': 'Subscribers',
   'service-request': 'Service request',
   'request-intake-form': 'Intake form',
   details: 'Details',
   'request-payment-form': 'Pay for service',
   'service-request-post-info-title': 'Thanks for using',
   'select-service': 'Select service to use',
   'field-empty': 'Please, fill this field.',
   'all-encounter-types': 'All encounter types',
   'all-doctors': 'All doctors',
   'subs-price': 'Price for subsсribers',
   'medication-name-placeholder': 'Name',
   'dose-placeholder': 'Dose',
   'frequency-placeholder': 'Frequency',
   'disease-placeholder': 'Disease',
   'add-medication': 'Add medication',
   packages: 'Packages',
   'diseases-placeholder': 'Disease(s)',
   'surgery-placeholder': 'Surgery',
   'date-surgery-operation-placeholder': 'Date',
   'attachable-label': 'User can attach files to intake form',
   'service-price-invalid': 'Service price invalid',
   'currently-label': 'Currently',
   'former-label': 'Former',
   'status-label': 'Status',
   'membership-description': 'Description',
   'no-plans-yet': 'No plans yet',
   'membership-duration-invalid': 'Membership duration invalid',
   'never-label': 'Never',
   'initial-price': 'Initial price',
   'access-to-platform': 'access to platform',
   'packages-title': 'Packages',
   'add-membership': 'Add membership',
   'memberships-tab-header': 'Memberships',
   'services-tab-header': 'Services',
   'to-label-fax': 'To (fax)',
   'active-label': 'Active',
   'inactive-label': 'Inactive',
   'to-label-email': 'To(email)',
   'edit-service-label': 'Edit service',
   'tobacco-label': 'Tobacco',
   'alcohol-label': 'Alcohol',
   'drugs-label': 'Drugs',
   'canceled-subscription': 'Canceled membership',
   'labs-label': 'Labs',
   'payments-label': 'Payments',
   'empty-lab': 'Please, choose a lab',
   'add-lab': 'Add lab',
   'notes-field-selector-label': 'Visit notes',
   'diagnoses-field-selector-label': 'Diagnoses',
   'imagings-field-selector-label': 'Imaging orders',
   'labs-field-selector-label': 'Lab orders',
   'prescriptions-field-selector-label': 'Prescriptions',
   'medicalCardRecords-field-selector-label': 'Medical History',
   'first-name-empty': 'Please type first name',
   'last-name-empty': 'Please type last name',
   'phone-number-empty': 'Please type phone number',
   'phone-number-invalid': 'Please type valid phone number',
   'timezone-empty': 'Please select timezone',
   'save-to-contacts': 'Save to contacts',
   'delete-prescription-confirmation-title': 'Confirm prescription deletion',
   'delete-prescription-confirmation-text': 'Do you really want to delete prescription?',
   diagnoses: 'Diagnoses',
   support: 'Support',
   export: 'Export',
   'export-chat': 'Export chat',
   'create-new-encounter': 'Create new encounter',
   'select-media-to-export': 'Select media to export',
   'select-period-to-export': 'Select period to export',
   'download-archive': 'Download archive',
   images: 'Images',
   'attach-note-to-encounter': 'Attach note to encounter',
   'choose-fields': 'Choose fields',
   'unexpected-error': 'An unexpected error occurs. Please, try to reload page or contact support',
   'contact-support': 'Contact support',
   'leave-review': 'Leave review',
   'doctor-profile': 'Doctor Profile',
   'consultation-access-denied': 'You don\'t have access to this consultation',
   'consultation-not-found': 'The consultation is not found',
   'consultation-canceled': 'The consultation was cancelled',
   'consultation-finished': 'The consultation has already finished',
   'lab-title': 'Lab title',
   'consultation-finished-info': 'The consultation is finished',
   'consultation-ended': 'The consultation has already ended',
   'consultation-not-started': 'The consultation has not started yet',
   'consultation-force-logout': 'Someone joined to consultation from your account',
   'exit-label': 'Exit',
   'enter-zip-code': 'Enter your ZIP code',
   'enter-phone': 'Enter your phone number',
   'medical-info': 'Medical info',
   'preferred-pharmacy': 'Preferred pharmacy',
   'enter-city': 'Enter your city',
   'secondary-address-optional': 'Address 2 (optional)',
   'wait-doctor': 'Wait for the doctor to join',
   'wait-patient': 'Wait for the patient to join',
   'video-unavailable': 'Video is unavailable',
   'browser-not-supported-header': 'Your browser does not<br> support WebRTC.',
   'browser-not-supported-text': 'Please switch the session to Google Chrome<br\> or Mozilla Firefox.',
   'mobile-chrome-not-supported-text': 'Please switch the session to Safari.',
   'about-to-start': 'You\'re about to start a consultation with',
   'encounter-empty': 'Please, select encounter',
   'media-device-error-note': 'Anytime you will be able to mute cam/mic inside the room',
   'consultation-anyway': 'Continue the consultation anyway',
   'busy-device-error': 'Another program uses your camera. Please close the program and try again.',
   'no-camera-microphone-error': 'Please connect your camera and microphone and try again.',
   'no-camera-error': 'Please connect your camera and try again.',
   'no-microphone-error': 'Please connect your microphone and try again.',
   'access-device-error': 'Please allow access to your camera in the browser settings and try again.',
   'chrome-provide-access-note': 'Please click the camera icon next to the star in the right of the address bar.',
   'ff-provide-access-note-1': 'Please click the camera icon at the left of the address bar.',
   'ff-provide-access-note-2': 'Therefrom, click the X next to the camera and microphone permissions, then reload.',
   'not-vma-email': 'This email not belongs to VMA',
   'macro-full-name': 'Macro\'s full name',
   'shortcut-already-exists': 'Macro with this shortcut already exist',
   type: 'Type',
   'error-send-message-title': 'Error',
   'video-chat': 'Video chat',
   'error-send-message-text': 'You cannot send message to this chat',
   shortcut: 'Shortcut',
   'phone-empty': 'Please, enter a phone number',
   'drag-drop-to-upload': 'Drag & Drop files here to upload',
   'upload-file': 'Upload file',
   'see-calendar': 'See calendar',
   'past-meetings': 'Past meetings',

   'pharmacy-note': 'Please enter your pharmacy of choice. Write at least 3 symbols to search a pharmacy. If you haven\'t found a certain pharmacy, please add more address details.',
   'title-placeholder': 'Title',
   'add-service': 'Add service',
   'title-empty': 'Please type a title',
   'comment-label': 'Comment',
   'delete-label': 'Delete',
   'medical-record-confirm-text': 'Are you sure you want to delete this record?',
   'medical-record-confirm-title': 'Confirm deletion',
   'no-consultation-yet': 'No consultation yet',
   'email-empty': 'Please enter email',
   'email-invalid': 'Please enter a valid email',
   'reported-medications': 'Reported medications',
   'height-invalid': 'Please enter a valid height',
   'weight-invalid': 'Please enter a valid weight',
   'address-empty': 'Please, enter an address',
   'select-date-time': 'Select date and time',
   'to-empty': 'Please type destination email/fax',
   'referral-to-empty': 'Please, enter Referral To',
   'referral-to-label': 'Referral To',
   'referrals-field-selector-label': 'Referrals',
   'name-empty': 'Please enter first name',
   'surname-empty': 'Please enter last name',
   'height-label': 'Height (inches)',
   'height-label-no-units': 'Height',
   available: 'Available',
   'not-available': 'Not available',
   'weight-label': 'Weight (pounds)',
   'weight-label-no-units': 'Weight',
   'organization-address-note': 'Outgoing prescriptions, orders and referrals will display organization address, phone, and fax unless requested otherwise',
   'fill-profile-first': 'Please complete your Bio and health history under your Profile.',
   'confirm-file-deletion-title': 'Confirm medical file deletion',
   'confirm-file-deletion-text': 'Are you really want to delete medical file?',
   'amount-exceed-available': 'The value exceeds the transaction\'s amount!',
   'payout-succeed': 'The payout was successful!',
   'payout-error': 'An unexpected error occurs, while trying to payout. Please, try again later!',

   // Twilio errors
   '21203-to': 'Access denied for this number',
   '21211-to': 'Number is invalid',
   '14111-to': 'Is not a valid destination for trial accounts',

   'medical-files-header': 'All files',
   'diagnostic-imaging-includes-header': 'Physician Referral for Diagnostic Imaging includes:',
   'diagnostic-imaging-includes-body': '- One Physician Referral (Doctor\'s Order/Prescription) sent to an imaging center of your choice. Additional referrals subject to additional fees.',
   'empty-text': 'All medical records will appear here.',
   'total-commission': 'Total earned on platform commission',
   'total-received-from-patients': 'Total received from patients',
   'refund-transaction': 'Refund transaction',
   'refund': 'Refund',
   'total-transactions': 'Total transactions',
   'empty-note': 'Heretofore... nothing yet.',
   'remove-label': 'Remove',
   'amount-invalid': 'This amount is invalid',
   'drop-to-upload-file': 'Drop to upload file',
   'send-review-comment-label': 'Your comment',
   'balance-history': 'Payment history',
   'succeeded': 'Suceeded',
   'refunded': 'Refunded',
   'has-no-supported-type': 'File has not supported type',
   'is-over-sized': 'File is oversized',
   'date-from': 'Date From',
   'date-to': 'Date To',
   'load-files-error-title': 'File upload error',
   'all-statuses': 'All statuses',
   'subscription-action': 'Membership action',
   'cancelImmediately': 'Cancel membership immediately',
   'amount-empty': 'Please, enter an amount',
   'cancelAtPeriodEnd': 'Cancel membership at period end',
   'notCancel': 'Not cancel membership',
   'payment-for': 'Payment for',
   'date': 'Date',
   'services-bought': 'Services bought',
   'amount': 'Amount',
   'cirrusMed/transactionStatusTypes/REFUNDED': 'Refunded',
   'cirrusMed/transactionStatusTypes/SUCCEEDED': 'Succeeded',
   'cirrusMed/transactionStatusTypes/PENDING': 'Pending',
   'all-payments': 'All payments',
   'cirrusMed/transactionTypes/MEMBERSHIP': 'Memberships',
   'subscriptions-and-services': 'Memberships & Services',
   'patients-subscription': 'Patient\'s membership',
   'subscription-bought': 'Membership bought',
   'subscription-expires': 'Membership expires',
   'patients-service': 'Patients\'s service',
   'cirrusMed/transactionTypes/SERVICE': 'Services',
   'transactions': 'Transactions',
   'cltv': 'CLTV',
   'include-cltv': 'Include CLTV Statistics in the report',
   'cltv-transactions': 'CLTV: Transactions',
   'cltv-gross-profit': 'CLTV: Gross profit',
   'payment-for-subscription-to': 'Payment for membership to',
   'load-files-error-text': 'The error occurs while try to upload files. This files has errors and cannot be uploaded:',

   'send-review-decline-title': 'Please tell us your reason',
   'send-review-decline-text': 'Thank you for taking time to let us know why you would like to decline %s %s services',
   'send-review-title': 'Rate your experience',
   'send-review-text': 'Your opinion is important to us. Tell us about your experience with %s.  Add a comment to your rating',
   'send-review-comment-placeholder': 'Add a comment to your rating',
   'reason-declined-label': 'Please specify the reason*',
   'optional-note': 'Optional',
   'reviews': 'Reviews',
   'review': 'Review',
   'rating': 'Rating',
   'no-significant': 'No significant',
   'use-organization-address': 'Use organization Address/Info',
   'discontinued-at': 'Discontinued At',

   'no-significant-allergies': 'No significant allergies',
   'add-allergies': 'Add allergies',
   'no-significant-family-history': 'No significant family history',
   'add-family-history': 'Add family history',
   'your-medical-history-helpful': 'You medical history will be also helpful for doctors',
   'no-significant-medical-history': 'No significant medical history',
   'add-medical-history': 'Add medical history',
   'no-significant-surgical-history': 'No significant surgical history',
   'add-surgical-history': 'Add surgical history',
   'no-significant-medications': 'No significant medications',
   'add-medications': 'Add medications',


   'new-consultation-title': 'You have a new consultation',
   'new-vma-consultation': 'Dr. %s have a new consultation',
   'new-consultation-body': ' has scheduled a consultation on %s',
   'cancelled-consultation-title': 'Consultation has been canceled',
   'cancelled-consultation-body': 'Your consultation on %s has been cancelled by %s %s',
   'cancelled-show-more': 'see the reason',
   'new-message-title': 'New message from ',
   'state': 'State',
   'choose-licensed-doctor': 'Please, choose a doctor licensed in your state.',
   'service-turned-off-text': 'Sorry, this service was just turned off by the doctor',
   'service-turned-off-title': 'Service disabled',
   'option-turned-off-title': 'Option disabled',
   'option-turned-off-text': 'Sorry, this membership was just turned off by the doctor',
   'time-date': 'Time  ·  Date',
   upcoming: 'Upcoming',
   past: 'Past',
   'login-as-this-user': 'Log In as This User',
   'login-as-this-doctor': 'Log In as This Doctor',
   'encounter-label': 'Encounter',
   'upcoming-consultation-title': 'Consultation with %s %s',
   'upcoming-consultation-body': 'Your consultation with %s %s is going to start in 15 minutes',
   'medical-condition-placeholder': 'Medical condition',
   'living-label': 'Living',
   'deceased-label': 'Deceased',
   'familyMember-placeholder': 'Family member',
   'medicalCondition-placeholder': 'Medical condition',
   'isLiving-label': 'Living',
   'isDeceased-label': 'Deceased',

   'ok-label': 'Ok',
   'consultation-schedule-error-title': 'An error has happened during the slot booking',
   'consultation-time-busy': 'Sorry, this time is not available anymore',

   medicalCardRecords: 'Medical card records',
   today: 'Today',
   yesterday: 'Yesterday',
   'message-notification-with-file': 'Sent you a file',
   message: 'Message',

   'message-notification-with-files': 'Sent you files',
   'own-message-notification-with-file': 'You sent a file',
   'own-message-notification-with-files': 'You sent files',

   'choose-doctor-error-title': 'An error has happened during the doctor choosing',
   'doctor-disabled-error': 'We are sorry, this doctor is not available anymore',
   'change-doctor-label': 'Change doctor',
   'confirm-finish-consultation': 'Are you sure you want to finish the consultation?',
   'all-membership-status': 'All membership status',
   'sharing-imaging-message': 'Hi, I\'m sharing the imaging order with you, it is attached to this message as a PDF file.',
   'sharing-lab-message': 'Hi, I\'m sharing the lab result with you, it is attached to this message as a PDF file.',
   'non-subscribers-price': 'Non Subscribers',

   current: 'Current',
   'payment-dialog-header': 'Pay for membership',
   'send-to-patient': 'Send to Patient',
   'month-interval': 'month',
   'month-interval-plural': 'months',
   'submit-label': 'Submit',
   'card-number-label': 'Card number',
   'card-number-placeholder': 'As it appears on your card',
   'cvc-label': 'Security code',
   'cvc-placeholder': 'CVC',
   'card-date-label': 'Expiration',
   'cardHolder-label': 'Card holder name',
   'cardHolder-placeholder': 'As it appears on your card',
   'me-label': 'Me',
   'membership-status-label': 'Packages status',
   'last-visit-label': 'Last visit',
   'date-label': 'Date',
   'time-label': 'Time',
   'encounter-type': 'Encounter type',
   'new-encounter-title': 'New encounter',
   processing: 'Processing',
   'send-one-document': 'Send in one document',
   'approve-consultation-title': 'Consultation approved',
   'approve-consultation-body': '%s approved consultation on %s',
   'decline-consultation-title': 'Consultation declined',
   'decline-consultation-body': '%s declined consultation on %s',
   'reschedule-consultation-title': 'Consultation rescheduled',
   'reschedule-consultation-body': '%s rescheduled planned consultation for %s. New time: %s',
   'additional-sig-label': 'Additional sig',
   'daw-label': 'DAW',
   'consultation': 'Consultation',
   'donot-have-doctors-yet': 'You don\'t have any doctors yet.',

   invalid_cvc: 'Invalid cvc',
   incorrect_cvc: 'Incorrect cvc',
   'approveConsultation-notification-type': 'Approve consultation',
   'declineConsultation-notification-type': 'Decline consultation',
   'rescheduleConsultation-notification-type': 'Reschedule consultation',
   card_declined: 'Card declined',
   'grant-membership': 'Grants %s %s membership',
   'already-connected-google': 'This account is already connected to google',
   expired_card: 'Card is expired',
   processing_error: 'Card processing error',
   'request-label': 'Request ',
   'free-label': 'Free',
   'hide-members-services': 'Hide members\' services',
   'show-members-services': 'Show members\' services',
   'included-label': 'Included in your membership',
   'sent-at': 'Sent at',
   'field-name': 'Field name',
   'field-type': 'Field type',
   'field-placeholder': 'Placeholder',
   'field-name-empty': 'Please, enter field name',
   'field-type-empty': 'Please, enter a field type',
   'service-name-empty': 'Please, enter a service name',
   'title-label': 'Title',
   days: 'Days',
   weeks: 'Weeks',
   months: 'Months',
   'text-input': 'Text input',
   'text-area': 'Text area',
   'totals': 'Total Patients',
   'payment-server-error': 'We are sorry, we can\'t complete your payment now. Please try again or contact support',
   'interval-count-weeks-error': 'For renewable memberships, the interval count cannot exceed 52 weeks',
   'interval-count-days-error': 'For renewable memberships, the interval count cannot exceed 365 days',
   'interval-count-years-error': 'For renewable memberships, the interval count cannot exceed 1 year',
   'interval-count-months-error': 'For renewable memberships, the interval count cannot exceed 12 months',
   'current-subscription-label': 'Current membership',
   'subscription-left': '%s left',
   subscription: 'Membership',
   'upgrade-label': 'Upgrade',
   'no-subscription': 'No membership',
   'active-subscription': 'Active membership',
   'active-subscription-short': 'Active',
   'cancel-subscription-dialog-title': 'Cancel membership',
   continue: 'Continue',
   'membership-agreement-error': 'Please, read a membership agreement',
   'member-label': 'Member',
   'condition-label': 'Medical condition',
   payment: 'Payment date',
   'end-date': 'End date',
   'payment-short': 'Payment',
   'end-date-short': 'End',
   'edit-plan': 'Edit plan',
   'become-a-cirrusmed-physician': 'Become a CirrusMED Physician',
   'refund-policy': 'Refund Policy',
   BASE: 'Base Ingredient',
   NAME: 'Medication Name',
   GROUP: 'Group',
   'allergy-type': 'Allergy type',
   'allergy-name': 'Allergy name',
   'download-link-text': 'If download doesn\'t start automatically, please click - ',
   here: 'here',
   'download-encounter-title': 'Download encounter',
   partners: 'Partners',

   'sms-consent': 'SMS Consent',
   'membership-agreement': 'Membership agreement',
   'memberships': 'Memberships',
   'memberships-and-services': 'Memberships and services',
   'read-membership-agreement-label': 'By making a payment, I agree with',
   'membership-agreement-low': ' membership agreement.',
   'post-info-popup-text': 'Thank you for requesting an imaging referral. Your doctor will review the request and, if clinically indicated, will send the referral to the imaging center. You may contact the imaging center directly to schedule your diagnostic test. We will share the final report with you upon receipt',
   'add-promo-code': 'Add promo code',
   'upgrade-subscription-header': 'Please upgrade membership',
   'upgrade-subscription-text': 'Your membership has expired! If you want to continue using the platform please purchase another one.',
   'upgrade-no-subscription-text': 'You have no membership! If you want to continue using the platform please purchase it.',
   'cancel-subscription-dialog-text': 'Are you sure to cancel membership at end of the paid period (%s)?',
   'expired-subscription': 'Expired membership',
   'expired-subscription-short': 'Expired',
   'duration-notice': 'This determines how long this coupon will apply once redeemed on a membership or customer.',
   'redemptionLimit-notice': 'This limits the total number of times this coupon can be redeemed. Leave empty or 0 for unlimited promo code.',
   'cancelled-subscription': ' (Cancelled)',
   'transaction-retry-count-exceed': 'The operation has not been completed because of hardware problems. It will recover as soon as possible.',
   'pay-credit-card': 'Pay with Credit card',
   'request-referral-label': 'Request a Referral for Imaging',
   'request-imaging-referral': 'Request Imaging Referral',
   'finish-label': 'Finish',
   'choose-doctor-label': 'Choose a doctor',
   'promo-empty': 'Please, fill promo code',
   'promo-invalid': 'Promo code name can consist only letters and numbers',
   'invalid-percentageDiscount': 'Percentage discount must be greater than 1 and less than 100',
   resource_already_exists: 'Coupon already exists',
   'duration-invalid': 'Duration must be once or forever',
   'no-available-users-to-remove': 'There are no available users to remove',
   'category': 'Category',
   'phone': 'Phone',
   'fax': 'Fax',
   'invalid-redemption-limit': 'Redemption limit value must be greater than 0',
   'no-search-results': 'No search results',
   'diagnosis-dropdown-other': 'Other diagnoses',
   'problem-list': 'Problem list',
   vitals: 'Vitals',
   'mmhg-label': 'mmHg',
   'beats-pm-label': 'beats per minute',
   'breaths-pm-label': 'breaths per minute',
   'vitals-imports-available-label':
      `Seems like this patient has some data from intake forms that wasn't properly imported.
Please press this button to import it properly.`,
   'vitals-import-button-label': 'Import',
   'vitals-import-error-label':
      `Something went wrong during the import process.
Please contact support.`,
   'vitals-import-items-imported': 'Successfully imported %i items from intake forms.',
   'diagnosis-dropdown-problems': 'Problem List',
   'header-title': 'A BETTER TELEHEALTH EXPERIENCE',
   'read-more-label': 'Read more',
   'promo-codes': 'Promo codes',
   'promo-label': 'Promo code',
   'percentageDiscount-label': 'Percentage discount',
   'duration-label': 'Duration',
   'redemptionLimit-label': 'Redemption limits',
   'applied-times-label': 'Applied times',
   once: 'Once',
   forever: 'Forever',
   'continue-label': 'Continue',
   'purchase-membership': 'Purchase membership',
   'membership-agreement-title': 'Cirrus Medical Network Membership Agreement',
   'membership-agreement-text':
      `<P>CIRRUS
        MEDICAL NETWORK

     <P><BR>
     <P>MEMBERSHIP
        AGREEMENT

     <P><BR>The
        terms of this Membership Agreement ("<B>Agreement</B>")
        hereby govern your use of our services effective as of the
        date of acknowledgment on the website
        ("<B>Effective
        Date</B>").&nbsp;
        Cirrus Medical Network, LLC, a Nevada limited liability company,
        doing business as CirrusMED ("<B>CirrusMED</B>",
        "<B>we</B>",
        "<B>us</B>",
        or "<B>our</B>")
        provides health data management, communication and related
        administrative services through its web-based, smart communications
        platform for US healthcare providers and consumers (collectively,
        "<B>CirrusMED
        Platform</B>").
        CirrusMED's technologies include, but are not limited to, its
        website located at www. CirrusMedicalNetwork.com, the CirrusMED
        mobile application (CirrusMED.com),
        communication services, and other technology provided by CirrusMED to
        Members via a subscription and paid-for "<B>Membership</B>".
        Registered members ("<B>Member(s)</B>","<B>you</B>",
        "<B>your</B>",
        or "<B>user</B>")
        include individuals authorized by CirrusMED to utilize the services
        provided by CirrusMED and includes those individuals acting on behalf
        of an authorized Member.

     <P>&nbsp;
     <P>CirrusMED
        Platform is used by healthcare providers to make available to Members
        certain diagnostic routine
        regardless of medical condition or necessity virtual health
        assessment exams, and related follow-up exams  (collectively
        "<B>Telehealth
        Assessments</B>").
        Telehealth Assessments are provided by an affiliated but separate
        Telehealth healthcare provider ("<B>Telehealth
        Provider</B>")&nbsp;
        utilizing the CirrusMED Platform. CirrusMED does not practice
        medicine and does not control the method or means of any Telehealth
        Provider's delivery of any healthcare or medical services via the
        Telehealth Assessments or CirrusMED Platform (the Telehealth
        Assessments and CirrusMED Platform services are collectively referred
        to as "<B>Services</B>").
        Telehealth Assessments are delivered on a routine, regardless of
        medical condition or necessity basis, and the&nbsp; CirrusMED
        Platform is solely in support of and facilitates the Telehealth
        Assessments, rendering the Services entirely outside any public or
        private healthcare insurance plan ("<B>Plan</B>")
        coverage or reimbursement. (CirrusMED and CirrusMED Members shall be
        referred to individually as "<B>Party</B>"
        or collectively as the "<B>Parties</B>").

     <P><BR>
     <P>&nbsp;
     <P>AGREEMENT&nbsp;
     <P>&nbsp;
     <OL>
     <LI>
        <P>
           <U>ACCOUNT
           REGISTRATION AND SECURITY</U>.
           You may use the Services only if you are eighteen (18) years or
           older and solely for your own personal, non-commercial use. To
           access certain features of the Services or to become a Member, you
           will have to create an account via the website at www.
           CirrusMedicalNetwork.com or the CirrusMED web
           app (CirrusMED.com). It is important that you provide us with
           accurate and complete information for your account and update as
           needed. You are responsible for protecting your account username and
           password, and for all activities that occur under your account. You
           should immediately notify us of any unauthorized use of your
           account. You should use caution when accessing your account from a
           public or shared computer so that others are not able to view or
           record your password or other personal information. We will not be
           responsible for any loss or damage if you do not protect your
           account or your personal information.

        <P>
           <BR>

     <LI>
        <P>
           <U>MINORS.</U>
           Some Members may be minors. A minor Member will be enrolled by such
           Member's custodial parent(s) or legal guardian.  If you are the
           parent or guardian of an unemancipated minor, you may use the
           Services and enter into a Membership  Agreement on behalf of such
           minor. By doing so, you represent and warrant that you have the
           legal capacity to act on behalf of such minor; and you acknowledge
           and agree, in such capacity, that all provisions of this Agreement
           applicable to you are equally applicable to such minor. Under no
           circumstances may our Services be used by anyone age 13 or younger.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>ACKNOWLEDGMENT
           OF&nbsp; MEMBERSHIP FEE</U>.
           CirrusMED charges a membership fee ("<B>Membership
           Fee</B>")
           for the availability of Services. Membership Fees and the Services
           they cover are described in Exhibit A annexed hereto. The Membership
           Fee may be modified by notice in accordance with this Agreement.
           Certain Members may have access to the CirrusMED Platform through
           their employers, professional affiliations, or other organizations,
           and as a result, the Membership Fee may not apply to such Members.
           The Membership Fee covers costs associated with the Services made
           available to Members. YOU MUST NOT SUBMIT TO ANY PUBLIC HEALTHCARE
           PLAN FOR REIMBURSEMENT OF MEMBERSHIP FEE. PAYMENT OF THE MEMBERSHIP
           FEE TO CIRRUSMED IS NOT A REQUIREMENT TO RECEIVE MEDICAL SERVICES
           FROM A TELEHEALTH  PROVIDER, OR FROM ANY OTHER HEALTHCARE PROVIDER.
           For questions related to the Membership Fee, contact CirrusMED by
           sending an email to&nbsp;support@cirrusmed.com.&nbsp;

        <P>&nbsp;
     <LI>
        <P>
           <U>BILLING.</U>
           For our Members, CirrusMED will charge your Membership Fee to your
           designated billing account. You agree to make the payment using the
           payment methods available on the CirrusMED Platform.&nbsp;If your
           account is subject to the Membership Fee, you authorize us to charge
           your chosen payment method the Membership Fee at the time of initial
           payment and each renewal term, until you cancel. You must cancel
           your Membership before it renews to avoid being charged the
           Membership Fee for the next time period.&nbsp;

        <P>
           <BR>

     <LI>
        <P>
           <U>SCOPE
           OF SERVICES</U>.
           Member acknowledges that:

        <P>
           <BR>

        <OL type="a">
     <LI>
        <P>
           CirrusMED
           is a technology and services company that assists Telehealth
           Providers and Members to communicate and exchange information more
           efficiently;

        <P>
           <BR>

     <LI>
        <P>
           CirrusMED
           does not engage in the practice of medicine and does not provide
           medical services;

        <P><BR>
     <LI>
        <P>
           Services
           do not include the provision of professional medical services;

        <P><BR>
     <LI>
        <P>
           CirrusMED
           does not employ or otherwise engage any physician to practice
           medicine or otherwise to provide medical services to any person,
           and no Telehealth Provider is an employee or representative of
           CirrusMED;

        <P><BR>
     <LI>
        <P>
           The
           patient-physician relationship between Member and any Telehealth
           Provider is strictly between the Member and the Telehealth Provider
           and not CirrusMED;

        <P><BR>
     <LI>
        <P>
           CirrusMED
           is not liable to Member for any Telehealth Provider's act or
           omission, or the method, means, quality or duration of any medical
           services;

        <P><BR>
     <LI>
        <P>
           Any
           medical services provided by any Telehealth Provider to Member are
           solely the result of that healthcare professional' medical
           judgment; and

        <P>
           <BR>

     <LI>
        <P>
           Rights
           and obligations of this Agreement are solely enforceable between
           CirrusMED and the Member, and do not involve any Telehealth
           Provider

        <P>
           &nbsp;

        </OL>
     <LI>
        <P>
           <U>MEMBERSHIP
           TERMINATION</U>.
           You may terminate your use of the Services and your Membership at
           any time by not using the Services anymore. If you wish to terminate
           your Membership, you can do so by logging into your CirrusMED
           account and selecting 'Cancel Membership' or by contacting us
           via email at support@cirrusmed.com. If you terminate your Membership
           and your subscription term has not expired, you may continue to use
           the Services until the end of your then-current Membership term and
           your Membership will not be renewed after your then-current term
           expires. However, you won't be eligible for a prorated refund of any
           portion of the Membership Fee paid for the then-current Membership
           period as Telehealth Providers have already scheduled Telehealth
           Assessment availability and CirrusMED has organized your Services
           for the applicable time period. We may terminate your use of the
           Services at any time by sending notice to you at the email address
           you provided or otherwise contacting you or posting a notice on the
           Services. If we terminate your use of the Services because you have
           breached this Agreement or any other agreement you have entered into
           with us, you will not be entitled to any refund of the paid
           Membership Fee.

        <P>
           <BR>

     <LI>
        <P>
           <U>TERMINATION
           NOTICE</U>.
           We are not required to provide you with notice prior to terminating
           your use of the Services or a reason for such termination. If we
           terminate your access to the Services other than due to your breach
           of this Agreement or any other agreement you have entered into with
           us, you will be entitled to a pro rate refund of the Membership Fee
           that you paid for the remainder of your Membership period.

        <P>
           <BR>

     <LI>
        <P>
           <U>APPLICATION
           FOR RETURN TO MEMBERHSIP</U>.
           If a Member of CirrusMED cancels a Membership, then CirrusMED shall
           have no obligation subsequently to permit the former Member to
           re-enroll as a Member.

        <P>
           <BR>

     <LI>
        <P>
           <U>MEDICAL
           CARE SERVICES EXCLUDED FROM MEMBERSHIP FEE.</U>
           The Membership Fee specified herein covers only the defined Services
           described in  Exhibit A. Except for your Services, you and/or your
           insurer, as the case may be, will be financially responsible for
           paying for all healthcare and medical care services received by you
           from your Telehealth Provider and his or her staff. Laboratory,
           imaging/x-rays, and other diagnostic testing are not included in our
           Services. The limited practice size also enables your Telehealth
           Provider to provide conveniences, such as 24/7 availability via
           secure messaging, video conferencing, in addition to enhanced
           coordination of specialist care, at no additional charge to you.

        <P>
           <BR>

     <LI>
        <P>
           <U>CO-PAYMENTS.</U>
           Since CirrusMED is a &quot;cash-only&quot; service, there will be
           no insurance billing. Therefore, you are not required to pay a
           co-payment, co-insurance or deductible unless your Telehealth
           Provider elects to provide you services covered by a public or
           private healthcare insurance plan ("<B>Plan</B>")
           and the Telehealth Provider is "in-network" with such Plan.

        <P>
           <BR>

     <LI>
        <P>
           <U>VARIED
           PAYMENT</U>.
           If the amount to be charged to you varies from the amount you
           preauthorized (other than due to the imposition or change in the
           amount of state sales taxes), for example, due to an increase in the
           Membership Fee, you have the right to receive, and we will provide,
           notice of the amount to be charged and the date of the charge at
           least thirty (30) days before the scheduled date of the transaction.
           If you do not agree with the new amount in the notice, you may
           cancel the transaction by logging into your account and select
           'Cancel Membership' or by contacting us at
           support@cirrusmed.com.

        <P>&nbsp;
     <LI>
        <P>
           <U>FREE
           TRIALS AND OTHER PROMOTIONS</U>.
           Any free trial or other promotion that provides paid Member-level
           access to the Services must be used within the specified time of the
           trial. If you do not wish to continue your Membership, you must
           cancel your trial membership before the end of the trial period in
           order to avoid being charged the Membership Fee, as applicable. If
           you cancel prior to the end of the trial period and are
           inadvertently charged for a Membership, please contact us
           at&nbsp;<A HREF="mailto:support@cirrusmed.com"><U>support@cirrusmed.com</U></A>&nbsp;for
           a refund.

        <P>
           <BR>

     <LI>
        <P>
           <U>REFUND
           POLICY</U>.
           Should you feel that a refund is warranted, please contact us first.
           To avoid delays in refunds, please do not contact your bank and do
           not file a dispute through your credit card company. This will only
           delay your refund. CirrusMED provides Services in exchange for a
           Membership Fee. Once the service has been completed, Membership Fees
           are no longer refundable. Specifically, for imaging referrals, once
           the referral has been sent to the imaging center, Members will have
           thirty (30) days to complete the test. After thirty (30) have
           lapsed, we shall close the referral, Membership will be canceled,
           and no refunds provided. If the Service is unable to be completed
           within the Membership time frame due to delays by the customer, a
           refund will not be provided. If thirty (30) days have elapsed from
           the end of Membership, Membership Fees will no longer be refunded.
           Membership Fees will only be refunded to the original payment source
           (e.g. Credit Card, PayPal).

        <P>&nbsp;&nbsp;
     <LI>
        <P>
           <U>USE
           OF THE SERVICES</U>.
           Subject to your compliance with this Agreement, we grant you a
           limited, non-exclusive, non-transferable, non-sublicensable license
           to use the CirrusMED Platform solely for your personal and
           non-commercial purposes. Your use of the CirrusMED Platform must be
           in accordance with all applicable laws. You acknowledge that you do
           not acquire any ownership rights in the CirrusMED Platform.&nbsp;The
           following is a list of the type of actions that you may not engage
           in with respect to the CirrusMED Platform:

        <OL type="a">
     <LI>
        <P>
           You
           will not use any robot, spider, site search/retrieval application,
           or other manual or automatic device or process to download, access,
           retrieve, index, &quot;data mine&quot;, or in any way reproduce or
           circumvent, avoid, bypass, remove, or deactivate the navigational
           structure or technical measures or presentation of CirrusMED
           Platform or its contents or Services;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not interfere, access, tamper with or disrupt the CirrusMED
           Platform or the servers or networks connected to the CirrusMED
           Platform;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not attempt to probe, scan or test the vulnerability of the
           CirrusMED Platform or any of our systems or network or breach any
           security or authentication measures;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not use any meta tags or other hidden text or metadata
           utilizing our trademarks, logos, URLs or product names without our
           express written consent;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not use the CirrusMED Platform or content, or any portion
           thereof, for any commercial purpose or for the benefit of any third
           party or in any manner not permitted by this Agreement;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not post, distribute, or reproduce in any way any content that
           infringes third party intellectual property rights or violates
           third party rights of privacy or rights of publicity;

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not use, display, &quot;frame&quot; or &quot;mirror&quot; any
           part of the CirrusMED Platform, our names, any of our trademarks,
           logos or other proprietary information, or the layout and design of
           any page or form contained on a page, without prior written
           authorization from us; and

        <P>
           &nbsp;

     <LI>
        <P>
           You
           will not collect or store any personal information, including
           personally identifiable information, from users without their
           express permission.

        <P>
           <BR>

        </OL>
     <LI>
        <P>
           <U>MEMBER
           OBLIGATIONS TO OBTAIN ACCESS.</U>
           Services are web-based services accessible through common user
           hardware and software that provide the user web access. Services do
           not consist of, and CirrusMED is not otherwise obligated by this
           Agreement to provide to Member, any hardware, devices, software, or
           third-party subscriptions necessary to permit Member to access the
           internet and use the Services. Member shall obtain the hardware,
           devices,
           software, and third-party subscriptions necessary for Member to
           access the internet and use the Services.

        <P>
           <BR>

     <LI>
        <P>
           <U>DOWNTIME;
           EMERGENCIES.</U>
           CirrusMED does not warrant or guarantee that all Services will be
           available during every moment. As with any technology, it is
           probable that Services will occasionally be unavailable because of
           planned and unplanned downtime. In recognition of these limitations,
           Member shall not use or rely on the Services to obtain assistance in
           a medical emergency or with respect to any urgent or emergent need
           or request for Medical Services.

        <P><BR>
     <LI>
        <P>
           <U>CIRRUSMED
           AND TELEHEALTH PROVIDER RELATIONSHIP</U>.
           All of the Telehealth Providers who deliver Services through the
           CirrusMED Platform are independent professionals solely responsible
           for the Services each performs for  Members. CirrusMED is not
           directly engaged in the practice of medicine or any other licensed
           profession and does not interfere with the practice of medicine or
           any other licensed profession by Telehealth Providers, each of whom
           is responsible for his or her services and compliance with the
           requirements applicable to his or her profession and license.
           Neither CirrusMED nor any third-parties who promote the Services or
           provide you with a link to the Services shall be liable for any
           professional advice you obtain from a treating Telehealth Provider
           via the Services. Our Services may include listings and directories
           to help you find Telehealth Providers that participate in our
           Services. Such information is provided for your convenience only and
           shall not constitute a recommendation or endorsement of any
           Telehealth Provider. Telehealth Provider lists and directories are
           not comprehensive but represent Telehealth Providers who have chosen
           to participate in the Services. Before obtaining Services or
           treatment from any Telehealth Provider listed in a directory, you
           should take the same care you would under any other circumstance,
           including by confirming licensure and specialty certifications. You
           should confirm such information before obtaining Services or
           treatment from any Telehealth Providers. As a convenience, the
           Services may permit you to request an appointment with a Telehealth
           Provider. However, Telehealth Providers are responsible for
           maintaining their own schedules, and we cannot ensure that any given
           Telehealth  Provider will be available, nor that such Telehealth
           Provider will not cancel his or her appointment.

        <P>
           <BR>

     <LI>
        <P>
           <U>PRESCRIPTION
           POLICY.</U>
           Telehealth Providers may offer prescriptions for a wide range of
           conditions within the scope of telemedicine. These include, but are
           not limited to, drug classes such as those listed below:

        <OL type="a">
     <LI>
        <P>
           Allergies,
           cold and flu

     <LI>
        <P>
           Antibiotics

     <LI>
        <P>
           Arthritis
           and pain (non-narcotic)

     <LI>
        <P>
           Asthma

     <LI>
        <P>
           Cholesterol

     <LI>
        <P>
           Diabetes

     <LI>
        <P>
           Ear
           health

     <LI>
        <P>
           Fungal
           infections

     <LI>
        <P>
           Gastrointestinal
           health

     <LI>
        <P>
           Heart
           health and blood pressure

     <LI>
        <P>
           Men's
           health

     <LI>
        <P>
           Mental
           health

     <LI>
        <P>
           Skin
           conditions

     <LI>
        <P>
           Thyroid
           conditions

     <LI>
        <P>
           Viruses

     <LI>
        <P>
           Vitamins
           and nutritional health

     <LI>
        <P>
           Women's
           health

     <LI>
        <P>
           Other
           medical conditions

        <P>
           <BR>

        </OL>
     <LI>
        <P>
           <U>LIMITED
           PRESCRIPTION POLICY.</U>
           CirrusMED is not a drug fulfillment warehouse. Members may have
           their prescription medications monitored and refilled per the
           discretion of their individual Telehealth Provider. In the event a
           Telehealth Provider prescribes medication, he/she will limit the
           supply based on state regulations. Telehealth Providers send
           prescriptions electronically to most U.S. pharmacies, including some
           "mail-order" pharmacies. We require a valid U.S. postal address.
           Electronic prescriptions may take up to one hour to arrive at your
           pharmacy. Short-term prescriptions for maintenance medicines may
           also be obtained in cases where you are transitioning
           to a new Telehealth Provider or traveling. Telehealth Providers DO
           NOT issue prescriptions for<A HREF="https://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf"><U>
           medicines controlled by the DEA*,</U></A>
           non-therapeutic, and/or certain other drugs which may be harmful
           because of their potential for abuse. Prescriptions are not
           available for international consults. Telehealth Providers will not
           prescribe the following controlled medications:

        <OL type="a">
     <LI>
        <P>
           Anxiety
           medications: XANAX (alprazolam), ATIVAN (lorazepam), VALIUM
           (diazepam), KLONOPIN
           (clonazepam)

     <LI>
        <P>
           Pain
           medications: NORCO/ VICODIN/ LORTAB (hydrocodone), PERCOCET
           (oxycodone), morphine, suboxone, dilaudid tramadol, butans,
           buprenorphine, fentanyl

     <LI>
        <P>
           Diet
           medications: PHENTERMINE, PHENDIMETRAZINE,
           QSYMIA, BELVIQ

     <LI>
        <P>
           Sleep
           medications: AMBIEN (zolpidem), LUNESTA, SONATA, BELSOMRA

     <LI>
        <P>
           ADD/ADHD
           medications: ADDERALL,
           RITALIN,
           CONCERTA, amphetamine,
           dexedrine

        </OL>
        <P>Here
           is a comprehensive list of controlled medications:
           <A HREF="https://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf"><U>https://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf</U></A>

        <P><BR>
     <LI>
        <P>
           <U>CONSENT
           TO ELECTRONIC COMMUNICATIONS</U>.
           You agree that CirrusMED or your Telehealth Provider may send the
           following to you by email or by posting them on our website and
           mobile application: legal disclosures; this Agreement; Privacy
           Policy; future changes to any of the foregoing; and other notices,
           policies, communications or disclosures and information related to
           the Services. When you visit our websites, we and certain
           third-party service providers collect information during your visit.
           In each case, the nature of the information we collect, the duration
           and manner of how we retain it, how we use it, and to whom we
           disclose it, is governed by our Cirrus Medical Network Privacy
           Policy or Cirrus Medical Network Membership Agreement, as
           applicable. You agree that CirrusMED and the Telehealth Provider may
           contact you via email, phone, text, or mail regarding your
           Membership or the Services. You consent to receive such
           communications electronically. You agree to update your contact
           information to ensure accuracy. Your consent to conduct actions
           electronically covers all interactions between you and CirrusMED and
           related potential communications with your Telehealth Provider. If
           you later decide that you do not want to receive certain future
           communications electronically, please send an email to
           support@cirrusmed.com or a letter to Cirrus Medical Network, 10627
           Professional Circle, Suite A, Reno, NV 89521. You may also opt-out
           of certain electronic communications through your account or by
           following the unsubscribe instructions in any communication you
           receive from CirrusMED. Your withdrawal of consent will be effective
           within a reasonable time after we receive your withdrawal notice
           described above.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>ELECTRONIC
           COMMUNICATIONS.</U>
           In providing Services to you, we may need to provide you with
           certain communications, such as service announcements and
           administrative messages. Such communication may be by email, a
           posting on our Services or some other mechanism. You consent to
           receive such communications from us electronically. If you have
           submitted information to us or registered to use the Services, our
           responses to you or our Service announcements and any administrative
           messages we provide are considered part of the Services themselves,
           which you may not be able to opt-out of those communications -
           e.g., communications regarding updates to the terms or information
           about billing. Your withdrawal of consent will not affect the legal
           validity or enforceability of the Agreement provided to and accepted
           by you. If you withdraw your consent to receive communications
           electronically, certain Services may become unavailable to you.
           Please refer to our Privacy Policy to learn how CirrusMED collects,
           uses, shares and protects your personal information and your
           protected health information.

        <P>
           <BR>

     <LI>
        <P>
           <U>E-MAIL
           COMMUNICATIONS; PRIVACY.</U>
           If you wish to send secure e-mail communications to, and receive
           secure e-mail responses from, your Telehealth Provider and/or his or
           her employees, agents and representatives, you should utilize the
           secure messaging provided through the <A HREF="https://cirrusmed.com/">https://CirrusMED.com</A>
           website.
           You should be aware that unlike the secure messaging provided
           through the <A HREF="https://cirrusmed.com/">https://CirrusMED.com</A>
           website,
           traditional e-mail is not a secure medium for sending or receiving
           potentially sensitive personal health information. You also
           acknowledge and understand that e-mail in any form is not a good
           medium for urgent or time-sensitive communications. In the event
           that communication  is time-sensitive you must communicate with your
           Telehealth Provider by telephone or video-conference.  You
           acknowledge and understand that, at the discretion of your
           Telehealth Provider, your email  may become part of your medical
           record.

        <P>&nbsp;
     <LI>
        <P>
           <U>PRIVACY.
           </U>CirrusMED's
           Privacy Policy applies to your access and use of the CirrusMED
           Platform, and the terms of conditions of CirrusMED's Privacy
           Policy are made part of this Agreement by this reference.
           Additionally, by using or accessing the CirrusMED Platform or
           Services, you acknowledge and agree that internet transmissions are
           never completely private or secure. You understand that any message
           or information you send to or through the CirrusMED Platform or
           Services, may be read or intercepted by others, even if there is a
           special notice that a particular transmission is encrypted.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>INDEMNITY</U>.
           You agree to defend, indemnify and hold CirrusMED and its
           affiliates, officers, directors, agents and employees harmless from
           and against any and all claims, losses, damages, liabilities and any
           other costs and expenses (including attorneys' fees) arising from or
           related to your: (i) use of the CirrusMED Platform or Services, (ii)
           your breach of any representation or warranty contained in this
           Agreement, or (iii) your failure to comply with, or other breach or
           default of or under, this Agreement.

        <P>&nbsp;
        </OL>
        <P><B>MISCELLANEOUS
           TERMS</B>

        <P>&nbsp;
        <OL>
     <LI>
        <P>
           <U>APPLICABLE
           REGULATIONS. </U>Recognizing
           the global nature of the Internet, Member agrees to comply with all
           local rules regarding online conduct and acceptable content.
           Specifically, Member will comply with all applicable laws regarding
           the transmission of technical data exported from the United States
           or the country from which the Member accesses Services online. As
           confirmed below, the laws of the State of Nevada, without
           application of choice-of-law principles of the State of Nevada,
           shall specifically apply to this Agreement and the enforcement
           thereof. We reserve the right to monitor all uses of our Services,
           and investigate any activity we suspect violates this Agreement, our
           rights or interests, or the rights or interests of any person or
           entity.&nbsp; We reserve the right, to the fullest extent permitted
           by law, to cooperate with any governmental authority or third-party
           investigating conduct that may be illegal or harm any individual or
           entity or violates their respective rights.

        <P>&nbsp;
     <LI>
        <P>
           <U>LEGISLATIVE,
           REGULATORY, OR ADMINISTRATIVE CHANGE</U>.
           In the event of a change in applicable federal and state statutes,
           case law, regulations&nbsp;or general instructions, the
           interpretation of any of the foregoing or the adoption of new
           federal or state legislation, any of which are reasonably likely to
           materially and adversely affect the manner in which either Party may
           perform or be compensated for its Services under this Agreement or
           which shall make this Agreement unlawful, Parties shall immediately
           enter into good faith negotiations regarding and use all reasonable
           efforts to enter into, a new arrangement pursuant to this Agreement
           that complies with such changed or adopted Law, regulation or policy
           in a manner which approximates, as closely as possible, the economic
           position of Parties prior to the change.

        <P>
           <BR>

     <LI>
        <P>
           <U>INTELLECTUAL
           PROPERTY RIGHTS</U>.
           CirrusMED and our licensors retain all ownership rights, title, and
           interest (including all intellectual property rights) worldwide to
           the Services, including all software and content. No rights are
           granted to you other than as expressly set forth in this Agreement.
           All trademarks, service marks and trade names are owned by Cirrus
           Medical Network, LLC, or other respective owners.

        <P>
           <BR>

     <LI>
        <P>
           <U>WAIVER
           OF PROPERTY RIGHTS.</U>
           Member understands that by providing any sample, having images and
           video data processed, accessing any images or videos captured using
           the Services provided by CirrusMED (collectively, "<B>Image
           Data</B>"),
           or providing information that Member enters into surveys, forms, or
           features while signed in to CirrusMED accounts including, but not
           limited to, health information, disease conditions, treatment
           information, healthcare provider information, and other information
           (collectively, "<B>Self-Reported
           Information</B>"),
           Member acquires no rights in any research or commercial products
           that may be developed by CirrusMED or its collaborating partners.
           Member specifically understands that Member will not receive
           compensation for any research or commercial product that includes or
           result from Image Data or Self-Reported Information.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>HYPERLINKS
           AND THE CIRRUSMED WEBSITE</U>.
           The Services provide, and third-parties may provide, links to other
           sites and resources on the Internet. Because CirrusMED has no
           control over such sites and resources, Member acknowledges and
           agrees that CirrusMED is not responsible for the availability of
           such external sites or resources and does not endorse and is not
           responsible or liable for any content, advertising, products, or
           other materials on or available from such sites or resources.&nbsp;Our
           Services may include advertisements or promotional messages
           sponsored by third-parties (collectively, "<B>Ads</B>").
           The manufacturers, service providers, distributors and resellers of
           the products and services identified in the Ads are solely
           responsible for the accuracy of their Ads and the suitability,
           efficacy, safety and quality of such products or services. An Ad
           does not in any way constitute or imply our recommendation or
           endorsement of such product or service. Member further acknowledges
           and agrees that CirrusMED shall not be responsible or liable,
           directly or indirectly, for any damage or loss caused or alleged to
           be caused by or in connection with use of or reliance on any such
           content, goods, or services available on or through any such
           hyperlinked site or resource.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>LINKS
           TO THIRD PARTY WEBSITES</U>.
           The Services may contain links to other sites that are owned and
           operated by third-parties. We are not responsible for the privacy
           and services practices or the content, advertising, products,
           services or other materials made available on or through any such
           linked sites. We provide these links to you only as a convenience,
           and the inclusion of any link does not imply endorsement of any kind
           by us.&nbsp; Such links do not constitute or imply our endorsement
           of such third-parties, or of the content of their sites, or the
           suitability, efficacy, safety or quality of their products or
           services, or the information privacy or security practices of their
           websites.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>DISPUTE
           RESOLUTION</U>.
           In the event of a dispute or disagreement between Parties with
           respect to this Agreement, either Party may request in writing a
           special meeting between Parties to resolve the dispute ("<B>Special
           Meeting</B>").
           The Special Meeting shall be held at a mutually agreeable location
           within ten (10) days of a written request for the meeting, which
           request shall specify the nature of the dispute to be resolved. The
           Special Meeting shall be attended by representatives of both Parties
           (who may or may not be accompanied by legal counsel, in their
           respective discretion), who shall attempt in good faith to resolve
           the dispute and shall have reasonable authority to do so. If Parties
           cannot resolve the dispute within thirty (30) days after such
           request for a meeting is given, the matter shall be submitted to
           arbitration, in accordance with the procedures outlined below. After
           the Special Meeting is held, any further dispute, claim or
           controversy arising out of or relating to this Agreement or the
           breach, termination, enforcement, interpretation or validity
           thereof, including the determination of the scope or applicability
           of this Agreement to arbitrate, shall be determined by arbitration
           in Reno, Nevada before one arbitrator. The arbitration shall be
           administered by JAMS pursuant to its Comprehensive Arbitration Rules
           and Procedures and in accordance with the Expedited Procedures in
           those Rules. Judgment on the Award may be entered in any court
           having jurisdiction. This clause shall not preclude parties from
           seeking provisional remedies in aid of arbitration from a court of
           appropriate jurisdiction. In the event a court action is brought to
           enforce or interpret any part of this Agreement, the prevailing
           Party shall be entitled to recover, as an element of its costs of
           suit, reasonable attorneys' fees, as determined by the court.
           Notwithstanding the provisions of this Section&nbsp;7 each of the
           Parties hereto shall have the right to apply for and obtain a
           temporary restraining order or other temporary, interim or permanent
           injunctive or equitable relief from a court of competent
           jurisdiction in order to enforce the provisions of any part of this
           Agreement as may be necessary to protect its rights under those
           Sections.

        <P>
           <BR>

     <LI>
        <P>
           <U>DISCLAIMERS.
           </U>To
           the maximum extent not prohibited by law, under no circumstances
           will we or any of our licensors, affiliates, employees, officers,
           directors or agents be responsible for any loss or damage, including
           personal injury or death, resulting from anyone's use of or
           inability to use the Services, or resulting from any content posted
           on the Services, or any claim related to the Services.&nbsp;

        <P>
           &nbsp;

     <LI>
        <P>
           To
           the maximum extent not prohibited by law, the Services are provided
           "as is" and "as available" without any warranties of any
           kind intended or implied.

        <P>
           &nbsp;

     <LI>
        <P>
           We
           and our licensors disclaim all warranties, express and implied,
           including, without limitation, any implied warranties of
           merchantability, fitness for a particular purpose, title and
           noninfringement, and warranties arising from course of dealing,
           course of performance and usage of trade related to Services. Your
           use of the Services is solely at your own risk. Furthermore, we and
           our licensors do not warrant that the Services will be
           uninterrupted or error-free, or that defects will be corrected.&nbsp;

        <P>
           &nbsp;

     <LI>
        <P>
           We
           do not warrant that files available for download related to
           Services will be free of viruses, worms, trojan horses or other
           destructive programming. Any material obtained through the use of
           the Services is accessed at your own discretion and risk, and you
           will be solely responsible for any damage to your computer system
           or loss of data that results from any such material. We make no
           warranty regarding the quality, accuracy, timeliness, truthfulness,
           completeness or reliability of any content.

        <P>
           &nbsp;

     <LI>
        <P>
           Any
           general advice that may be posted on CirrusMED's website(s) or
           CirrusMED's mobile app is for informational purposes only and is
           not intended to replace or substitute for any medical or other
           advice. To the maximum extent not prohibited by law, we make no
           representations or warranties and expressly disclaim any and all
           liability concerning any treatment, action by, or effect on any
           person following the general information offered or provided within
           or through the Services. If you have specific concerns or a
           situation arises in which you require medical advice, you should
           consult with an appropriately trained and qualified medical
           services provider.

        <P>
           &nbsp;

     <LI>
        <P>
           The
           Services are intended for use only within the United States and its
           territories. We make no representation that the Services are
           appropriate, or are available for use outside the U.S. Those who
           choose to access and use our Services from outside the U.S. do so
           on their own initiative, at their own risk, and are responsible for
           compliance with applicable laws.

        <P>
           &nbsp;

     <LI>
        <P>
           WITHOUT
           LIMITING ANY OF THE OTHER RISKS WE HAVE DISCLOSED TO YOU IN THIS
           AGREEMENT, YOU ARE SOLELY RESPONSIBLE FOR YOUR USE OF OUR SERVICES,
           INCLUDING ANY INFORMATION YOU SUBMIT TO US AND YOU EXPRESSLY
           ACKNOWLEDGE AND AGREE THAT YOUR USE AND ACCESS TO OUR SERVICES AND
           THE INFORMATION AND CONTENT CONTAINED THEREIN, AND ANY SITES LINKED
           THROUGH OUR SERVICES AND ANY DATA TRANSMITTED THROUGH OUR SERVICES
           IS AT YOUR SOLE RISK. ACCORDINGLY, WE DO NOT ASSUME ANY LIABILITY
           TO YOU FOR OR RELATING TO ANY OF YOUR ACTIONS.

        <P>&nbsp;
     <LI>
        <P>
           <U>EXCLUSIVE
           REMEDY</U>.
           If you are dissatisfied with the Services, your sole and exclusive
           remedy is to stop using the Services and cancel your Membership
           account with no refund owed for such cancellation.&nbsp;

        <P>&nbsp;
     <LI>
        <P>
           <U>NOTICE.&nbsp;</U>Any
           notice or other communication by either Party to the other shall be
           in writing and shall be deemed to have been given (i) if delivered
           in person to Party named below on the date of delivery, (ii) if made
           by facsimile transmission, at the time that receipt thereof has been
           acknowledged by electronic confirmation or otherwise; provided,
           however, if receipt occurs after 5:00 p.m. at the recipient's
           location then the next day, or (iii) delivered by certified or
           registered mail, postage prepaid, return receipt requested, or other
           reputable delivery service such as Federal Express, upon the date
           indicated on the return receipt if addressed as follows:

        <P>&nbsp;
        <P>If
           to Company:&nbsp;

        <P>Cirrus
           Medical Network, LLC (CirrusMED)

        <P>Attn.:
        <P>10627
           Professional Circle, Suite A

        <P>Reno,
           NV 89521

        <P>&nbsp;
        <P>If
           to CirrusMEDMember:

        <P>Name
           of CirrusMED Member

        <P>(address
           of CirrusMED Member)

        <P>&nbsp;
        <P>
           or at such
           other addresses,
           and to the attention of such other person, as either Party may
           designate in writing from time to time.

        <P>
           &nbsp;

     <LI>
        <P>
           <U>ASSIGNMENT.
           </U>This
           Agreement shall be binding upon, and shall inure to the benefit of,
           Parties and their respective legal representatives, successors, and
           assigns. Member may not assign this Agreement or any rights
           hereunder, nor may it delegate any of its duties to be performed
           hereunder, without the prior written consent of CirrusMED.

        <P>
           <BR>

     <LI>
        <P>
           <U>NO
           INTENDED THIRD-PARTY BENEFICIARIES. </U>None
           of the provisions contained in this Agreement are intended by
           Parties, nor shall they be deemed, to confer any benefit on any
           person not a party to this Agreement, including, without limitation,
           any healthcare professional, consumer, or patient of Telehealth
           Provider.

        <P>
           <BR>

     <LI>
        <P>
           <U>GOVERNING
           LAW</U>.
           This Agreement and the Exhibit attached hereto, and all extensions
           and modifications thereof shall be interpreted in accordance with
           the laws of the State of Nevada, without regard to or application of
           its conflict of law rules.

        <P>
           <BR>

     <LI>
        <P>
           <U>ENTIRE
           AGREEMENT; AMENDMENT</U>.
           This Agreement and any attached exhibit shall collectively
           constitute the entire Agreement between and understanding of Parties
           with respect to the subject matter of this Agreement, and as such
           this Agreement supersedes any prior agreements or negotiations
           between Parties, whether written or oral. No modification,
           amendment, or alteration to this Agreement or any instruments
           integrated herein by reference shall be effective unless in writing
           and signed by both Parties.

        <P>
           <BR>

     <LI>
        <P>
           <U>HEADINGS</U>.
           The paragraph headings set forth in this Agreement are for the
           purposes of convenience only and shall have no bearing whatsoever on
           the actual content or interpretation of this Agreement.

        <P>
           <BR>

     <LI>
        <P>
           <U>WAIVER
           OF BREACH</U>.
           No waiver of any of the provisions of this Agreement by CirrusMED
           shall be deemed to be or shall constitute a waiver of any other
           provision hereof by CirrusMED, whether or not similar, nor shall
           such waiver constitute a continuing waiver unless otherwise
           expressly provided.

        <P>
           <BR>

     <LI>
        <P>
           <U>REPRESENTATION.</U>
           The Member enrolling with CirrusMED through this Agreement hereby
           represents that he or she is enrolling for the bona fide purpose of
           obtaining the Services in connection with managing such Member's
           access to healthcare, and that all information provided to CirrusMED
           or entered into the CirrusMED Platform by such Member is true,
           accurate and not misleading. The Member entering into this Agreement
           has no right to use any CirrusMED systems, software, processes or
           information for any other purpose.

        <P>
           <BR>

     <LI>
        <P>
           <U>COUNTERPARTS.
           </U>This
           Agreement may be executed in several counterparts transmitted
           electronically, each of which shall be deemed an original; however,
           all of such counterparts shall together constitute one and the same
           Agreement.

        <P>
           <BR>

     <LI>
        <P>
           <U>SEVERABILITY</U>.
           Parties hereto have negotiated and prepared the terms of this
           Agreement in good faith with the intent that each and every one of
           the terms, covenants and conditions herein be binding upon and inure
           to the benefit of the respective Parties. Accordingly, if any one or
           more of the terms, provisions, promises, covenants or conditions of
           this Agreement or the application thereof to any person or
           circumstance shall be adjudged to any extent invalid, unenforceable,
           void or voidable, for any reason whatsoever, by a court of competent
           jurisdiction or an arbitration tribunal, such provision shall be as
           narrowly construed as possible, and each and all of the remaining
           terms, provisions, promises, covenants and conditions of this
           Agreement or their application to other persons or circumstances
           shall not be affected thereby and shall be valid and enforceable to
           the fullest extent permitted by law.&nbsp; To the extent this
           Agreement is in violation of applicable law, Parties agree to
           negotiate in good faith and in accordance with Section 2 to amend
           the Agreement, to the extent possible consistent with its purposes,
           to conform to such law.

        <P>
           <BR>

     <LI>
        <P>
           <U>FORCE
           MAJEURE. </U>CirrusMED
           shall not be liable for any failure, inability or delay to perform
           hereunder, if such failure, inability or delay is due to any cause
           beyond the reasonable control of CirrusMED.&nbsp;

        <P>
           <BR>

     <LI>
        <P>
           <U>ADDITIONAL
           DOCUMENTS</U>.
           Member agrees to execute any document(s) that may be reasonably
           requested from time to time by CirrusMED to implement or complete
           Member's obligations pursuant to this Agreement.&nbsp;

        <P>
           &nbsp;

     <LI>
        <P>
           <U>SURVIVAL.
           </U>Sections
           6 (Membership Termination), 3 (Intellectual Property Rights), 4
           (Waiver of Property Rights), 7 (Dispute Resolution), 10 (Notice) and
           22 (Survival) of this Agreement and any other provisions of this
           Agreement that are stated shall survive the termination or
           expiration of this Agreement.
           </LI>
           </UL>

        <P>
           <BR>

        <P>If
           you have any questions about this Agreement's terms, please contact
           <A HREF="mailto:support@cirrusmed.com"><U>support@cirrusmed.com</U></A>.

        <P>&nbsp;
        <P><BR>
        <P>IN
           WITNESS WHEREOF, Parties hereto have executed this Agreement
           effective as of the Effective Date.

        <P><BR>
        <P>Execution
           of this agreement effective and mutually agreed upon by electronic
           acknowledgment (e.g. clicking check box) on the Effective Date,
           required during registration on the website, CirrusMED.com.

        <P><BR>
        <P>Electronically
           acknowledged and accepted by registering CirrusMED Member  and

        <P>&nbsp;
        <P>COMPANY:&nbsp;
        <P><BR>
        <P>Cirrus
           Medical Network, LLC&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
           &nbsp;

        <P>10627
           Professional Circle, Suite A&nbsp;

        <P>Reno,
           NV 89521&nbsp;

        EMAIL:&nbsp;
           <A HREF="mailto:support@cirrusmed.com"><U>support@cirrusmed.com</U></A>&nbsp;
        PHONE:
           702.690.9711

        <P>EXHIBIT
           A

        <P><BR>
        <P><BR>
        <P>CIRRUSMED
           PLATFORM SERVICES AND MEMBERSHIP FEES

        <P><BR>
        <P>See
           <A HREF="https://cirrusmed.com/#plan-and-prices"><U>https://cirrusmed.com/#plan-and-prices</U></A>
           for current fees.

        <P><BR>
        <P>
           Cirrus
           Medical Network affiliate physicians offer Memberships and Services.

        <P>
           <BR><BR>

        <P>
           <B>Memberships</B>
           include online access to your doctor via secure text messaging and/or
           video chat appointments for the duration of your membership plan
           (e.g. monthly, every 3-months, or annually).

        <P>
           Memberships
           are recurring, similar to a subscription. As long as you are an
           active member, you may contact your doctor at any time. We offer both
           primary care and specialty care memberships.

        <P>
           <BR>

        <P>
           <B>Services</B>
           include online access to your doctor via secure text messaging and/or
           video chat appointments for the limited duration of your service plan
           (e.g. 1 week, 1 month).

        <P>
           Services
           are non-recurring, one-time payments. Examples include one-time
           imaging, lab, or<A HREF="https://cirrusmedicalnetwork.com/online-doctor-consultation-2/">
           </A><A HREF="https://cirrusmedicalnetwork.com/online-doctor-consultation-2/"><U>consultation
           requests</U></A>.
           Individual doctors may offer unique services related to their
           specialty.

        <P>
           <BR>

        <P>Cirrus
           Medical Network telehealth
           assessments may include any and/or all of the following:

        <UL>
           <LI>
              <P>Video
                 consultation by appointment

           <LI>
              <P>Asynchronous
                 chat/messaging

           <LI>
              <P>Review
                 of bio and medical history

           <LI>
              <P>Review
                 of intake forms and requests

           <LI>
              <P>Documentation
                 of  a clinical note, including history of present illness (e.g.
                 subjective information), objective findings, assessment/diagnosis,
                 and a plan

           <LI>
              <P>Ordering
                 of appropriate imaging and/or diagnostic studies

           <LI>
              <P>Review
                 of patient uploaded documents

           <LI>
              <P>Review
                 of incoming documents (e.g. results and reports)

           <LI>
              <P>Sharing
                 of  results of incoming reports with patient

        </UL>
        <P><BR>
        <P><BR>
        <P><B>FEES</B>
        <P><BR>
        <P>Virtual
           Direct Primary Care (DPC) membership fees are $59/month,
           $147/3-months or $468/ year. Primary Care Telehealth Providers:
           Family Medicine, Internal Medicine, MED/PEDS, Hospitalist, ER/Urgent
           Care, Pediatrics, OB/GYN

        <P><BR>
        <P>Virtual
           Direct Specialty Care (DSC) membership fees are $89/month, $237/3
           -months,or $828/year. Medical and surgical specialists providing DSC
           are those not listed under DPC. <A HREF="https://cirrusmedicalnetwork.com/price-plans-2/"><U>Click
           here for a comprehensive list of specialists.</U></A>

        <P><BR>
        <P>One-off
           Services include: 1-week access for $49, MRI/Diagnostic imaging
           referral with 1 month access for $59 for the first referral, and $30
           for subsequent referrals.

        <P><BR>
        <P>All
           providers chose which memberships and/or services they provide and
           they are visible on their profile.

        <P><BR>
        <P>Note
           that program pricing and services are subject to change.

        `,
   'how-it-work-shot': 'Shortly after signing up with Cirrus Medical Network, a “get to know you” virtual visit will be\n'
      + '                        scheduled with your new online primary care physician (PCP).\n'
      + '                        At this consultation, your medical record will be reviewed and any concerns of yours will be\n'
      + '                        addressed.',
   'how-it-work-full': `<p>CirrusMED brings together patients and doctors, online. Using today’s technology we provide direct care via telemedicine without the hassles of insurance or a third-party.
<p>Simply choose either a Membership Plan or a Service and then create your account.
<p>Once you have created your account, you will need to fill out your biographical information (Bio) and your medical history (Profile).
<p>Choose a doctor licensed in your State. He or she will be <b><i>your doctor, online.</i></b>
<p>Once you have completed the signup process and chosen a doctor, feel free to schedule a "get to know you" virtual visit with your new online physician. At this consultation, your medical record will be reviewed and any concerns of yours will be addressed. Acute, chronic, and wellness issues are all considered during this and all consultations with your CirrusMED-affiliated physician.
<p>As long as you are an active member, you may communicate with your doctor via messaging and video visits as often as you like.  You benefit from having the <b><i>same doctor</i></b>, each visit. No need to have to explain your story again, and again. This continuity of care is unique to CirrusMED.
<ul>Members may request:
 <li>Prescriptions (and refills)</li>
 <li>Laboratory tests (labs)</li>
 <li>Imaging tests (MRI’s, X-rays, etc.)</li>
 <li>Referrals</li>
 <li>Unlimited Consultations</li>
 <li>and more…</li>
</ul>
<p>You and your doctor may easily share files via the portal and add to your health record.
<p>Be sure to check out some of the <a href="/conditions-treated" target="_blank">common medical conditions treated online</a> by our physicians.
<p>If you purchase a specific service (e.g. MRI/Imaging referral), you may be asked to fill out a brief questionnaire. Your doctor will review this intake form and work with our team to complete the service in a timely fashion.
<p>Most importantly, we break down the barriers to care by opening up a direct line of communication between you and your doctor.
<p>Prescriptions are subject to our <a href="/prescription-policy" target="_blank">prescription policy</a>.
<p>Details of Cirrus Medical Network, LLC (CirrusMED) membership may be found in our <a href="/membership-agreement" target="_blank">membership agreement</a>.`,
   'about-us-title': 'Welcome to Cirrus Medical Network',
   'about-us-text': '<p>The premier online concierge doctor network, where you can retain your very own private physician for a nominal monthly fee. &nbsp;Whether you are a busy professional or a college student, you can avoid the hassle of traditional office-based medical practices by connecting with your Cirrus Medical Network (CirrusMED) physician 24/7 via secure online encounters such e-messaging and video-conferencing through virtual appointments.\n'
      + '<p><a href="https://cirrusmedicalnetwork.com/our-doctors/" target="_blank">Our physicians </a>are board-certified Primary Care Physicians (PCPs) with state licenses in your state. Upwards of 90% of primary care visit complaints can be managed via telemedicine or online. Go ahead and check out the list of <a href="/conditions-treated" target="_blank">conditions treated</a> online. Prescriptions are e-prescribed to your local pharmacy of choice. See our <a href="/prescription-policy" target="_blank">Prescription Policy</a>.\n'
      + '<p>With several <a href="https://cirrusmedicalnetwork.com/price-plans/" target="_blank">membership options</a>, you can choose the plan that fits your needs. A “VIP” option is available for those who seek instant access to their physician via phone or text messaging.\n'
      + '<p>All 3-Month Trial and Annual Packages membership come with a free <a href="https://cirrusmedicalnetwork.com/welcome-package/" target="_blank">"Welcome Package"</a> containing useful diagnostic tools such as a blood pressure monitor, thermometer, and pulse oximeter - all which aid your physician in making the right clinical decisions for your health.\n'
      + '<p>Unlike many telemedicine services, Cirrus Medical Network physicians are “your doctor” for as long as you like. Thus, you will get continuity of care just as you would if you were to establish care with an office-based primary care physician. You and your PCP will develop a rapport which will develop over time, so you can trust that your health is in good hands. Your online doctor can manage chronic medical conditions such as high blood pressure, diabetes, high cholesterol, as well as host of other conditions. Labs, X-rays, Diagnostic Studies, and Referrals are all utilized just as they are in an office-based setting and can be arranged online. Of course, all medical treatment is done within the scope of online consultations, and is ultimately determined by your CirrusMED-affiliated physician.\n'
      + '<p>Each Cirrus Medical Network member will receive a “get to know you” conference to go over any concerns and review one’s medical history. In addition, any routine wellness visits and/or follow-up visits can be scheduled as a virtual visit any time. No need to deal with a busy clinic’s phone system, reception, or a waiting room full of sick people.\n'
      + '<p>Your medical record is maintained in a HIPPA compliant secure cloud-based <a href="https://cirrusmedicalnetwork.com/my-online-health-record/" target="_blank">electronic health record (EHR)</a> that is available for your review at any time.\n'
      + '<p>If you truly value your health and your time, then you will appreciate having the enhanced doctor-patient relationship with a Cirrus Medical Network physician. Each CirrusMED-affiliated physician limits their online practice to no more than 400 patients. Therefore, as a Cirrus Medical Network member, you will get the medical attention you deserve. This is not WebMD, or Google MD..this is Your Doctor. Online.',
   'terms-and-conditions-text': `
<h2>CIRRUS MEDICAL NETWORK</h2>
<h2>TERMS AND CONDITIONS</h2>

<p>These terms of use (these “Terms”) govern your use <a href="https://www.cirrusmed.com">www.cirrusmed.com</a> <strong>(“Site”)</strong>, and any content made available from or through the Site, which is owned and operated by Cirrus Medical Network LLC, a Nevada limited liability company <strong>(“Cirrus Medical Network”)</strong>. Through the Site, Cirrus Medical Network provides an online telemedicine technology platform <strong>(“Platform”)</strong> allowing patients to connect with independent healthcare professionals in the field of medicine <strong>(“Telehealth Provider(s))</strong> and obtain certain medical and healthcare services <strong>(“Medical Services”)</strong>. These Terms, which are effective as of January 1, 2018  <strong>(“Effective Date”)</strong>, apply to anyone using or accessing the Site, Platform or Platform Services, including casual visitors of the Site who do not sign up for an account <strong>(“Site Visitors”)</strong> and users who have registered with Cirrus MED to use the Site, Platform or Services <strong>(“Registered Users”)</strong>.
<p>PLEASE READ THESE TERMS CAREFULLY BEFORE YOU ACCESS OR USE THE SITE OR PLATFORM, OR OTHERWISE USE OR PARTICIPATE IN OUR PLATFORM SERVICES. BY ACCESSING OR USING THE SITE OR PLATFORM, BY USING OR PARTICIPATING IN THE PLATFORM SERVICES, OR BY REGISTERING TO USE OR ACCESS ANY OF THE FOREGOING, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS, DO NOT ACCESS OR USE THE SITE OR PLATFORM, OTHERWISE USE OR PARTICIPATE IN OUR PLATFORM SERVICES, OR REGISTER TO USE OR ACCESS ANY OF THE FOREGOING, AND IMMEDIATELY EXIT THE SITE AND PLATFORM
<h2>General Terms</h2>
<p>By using or accessing the Site, Platform or Platform Services, you agree: (i) that you have read and understand these Terms and that these Terms create a valid and binding agreement, enforceable against you in accordance herewith; (ii) to be bound by these Terms and any terms, conditions or other policies of CirrusMED, as each may be amended or supplemented from time to time without notice; and (iii) that your use of the Site, Platform and Platform Services shall comply with all applicable federal, state, and local laws or regulations, and that you are solely responsible for your compliance with, familiarity with and understanding of any such laws applicable to your use. Additionally, and without limiting the foregoing, by using or accessing the Site, you represent and warrant that you: (a) are eighteen (18) years of age or older; (b) are not currently restricted from using the Site, Platform or Platform Services, or not otherwise prohibited from having a CirrusMED account; (c) are not a competitor of CirrusMED or are not using CirrusMED for reasons that are in competition with CirrusMED or any product or service offered by CirrusMED; (d) have full power and authority to enter into and perform these Terms, and doing so will not violate any other agreement to which you are a party; (e) will not violate any rights of CirrusMED, including intellectual property rights such as copyright or trademark rights; and (f) agree to provide at your sole cost all equipment, software, internet access and other items necessary to use or access the Site, Platform or Platform Services.
<h2>Registering to Use CirrusMED’s Services.</h2>
<p>When you sign up for an account through the Site to use the Platform Services, you will be asked to agree to the CirrusMED Membership Agreement and Patient Consent Form by checking a box or clicking on a button with terms such as “I agree” or “I accept”. In the event of a conflict between the terms of your Membership Agreement and of these Terms, the terms of your Membership Agreement shall control. You will also be asked to create a unique user ID and password (your “Login Credentials”). You should immediately notify us if you believe your Login Credentials have been stolen or compromised. You are responsible for all activities that occur under your Login Credentials until you have properly notified us that your Login Credentials have been stolen or compromised. Further, you represent, warrant and covenant that: (i) the information you submit in obtaining your Login Credentials is complete and accurate; (ii) you will not share your Login Credentials with anyone; (iii) you will not circumvent, or attempt to circumvent, any technical measures that we have implemented to safeguard the Platform Services; and (iv) you will not access or use, or attempt to access or use, our Platform without validly-issued Login Credentials.
<h2>Site Visitor Privileges</h2>
<p>As a Site Visitor, subject to your compliance with these Terms, you are granted the right to access certain portions of the Site solely for your personal, non-commercial use in connection with your evaluation of the Site, Platform or Platform Services, and your desire to become a Registered User. You may not (i) access, view, modify or otherwise use any portion of our Site, Platform or Platform Services not made expressly accessible to you, or (ii) modify, copy, distribute or otherwise use the Site, Platform, or Platform Services, in any manner other than for such evaluation, without our express permission.
<h2>Registered User Privileges</h2>
<p>As a Registered User, subject to your compliance with these Terms, you are granted a limited, non-exclusive, non-transferable, worldwide right to access, execute, display, perform, and otherwise use the Platform solely for your personal use of the Platform Services, provided that you shall not: (i) license, sublicense, sell, resell, distribute or otherwise commercially exploit the Site, Platform, or Platform Services to or for the benefit of any third party; (ii) modify or make derivative works based upon the Site, Platform, or Platform Services; or (iii) reverse engineer, reverse compile, or access the Site, Platform, or Platform Services in order to build a competitive product or service. You may access and view certain password-protected areas of our Site, Platform, or Platform Services for use solely in conjunction with the Platform Services and as provided in these Terms, and you may not otherwise modify, copy, distribute, or otherwise use the Site, Platform, or Platform Services.
<h2>Restrictions on Use</h2>
<p>To protect the confidentiality, integrity and availability of the information housed and shared on our Platform Services, you agree that you will not, nor will you attempt to: (i) access, use or disseminate our Platform Services, nor any information or files accessible via our Platform Services, in a manner that violates any applicable law or regulation or the rights of any individual or entity; (ii) sell or transfer any information included in our Platform Services or use such information to market any product or service – including by sending, or facilitating the sending of, unsolicited emails or “spam”; (iii) probe, scan or test potential vulnerabilities of our Platform Services, or of the system or network supporting our Platform Services, or circumvent any security or authentication measures; (iv) disable, bypass, defeat, avoid, remove, deactivate or otherwise circumvent any technical measures we have implemented to safeguard the stability of our Platform Services, or the confidentiality, integrity or availability of any information, content or data hosted or housed on our Platform Services; (v) introduce to our Platform Services any software, code or other device that in any way (x) permits unauthorized access to our systems or any software, hardware, files or data located thereon, (y) disables or damages or otherwise interferes with or adversely affects the operation of our systems or any software, hardware, files or data located thereon, or (z) overburdens or interferes with the proper functioning of our Platform Services; (vi) disassemble, decompile or reverse engineer our Platform Services; (vii) remove any copyright, trademark or other proprietary rights notices contained in or on our Platform Services; or (viii) engage in any activity other than those expressly permitted in these Terms and your Membership Agreement.
<h2>Use of the Services by and on behalf of Minors</h2>
<p>You are not eligible to use our Services (including obtaining Login Credentials or entering into a Membership Agreement) unless you are at least eighteen (18) years old and otherwise have the legal capacity to enter into a binding contract in your jurisdiction. If you are the parent or guardian of an non-emancipated minor, you may use the Services and enter into a Membership Agreement on behalf of such minor. By doing so, you represent and warrant that you have the legal capacity to act on behalf of such minor; and you acknowledge and agree, in such capacity, that all provisions of these Terms (and Membership  Agreement, if applicable) applicable to you are equally applicable to such minor. Under no circumstances may our Platform Services be used by anyone age thirteen (13) or younger.
<h2>Communications</h2>
<p>When you sign-up for, or log-in to, our Platform Services, or when you submit information on a web form or via email, you are communicating with us electronically. When you visit our Site, we and certain third-party service providers collect information during your visit. In each case, the nature of the information we collect, the duration and manner of how we retain it, how we use it, and to whom we disclose it, is governed by our CirrusMED Privacy Policy or CirrusMED Membership Agreement, as applicable. In providing Platform Services to you, we may need to provide you with certain communications, such as service announcements and administrative messages. Such communication may be by email, a posting on our Platform Services or some other mechanism. You consent to receive such communications from us electronically. If you have submitted information to us or registered to use the Platform Services, our responses to you or our Platform Services announcements and any administrative messages we provide are considered part of the Platform Services themselves, which you may not be able to opt-out from. You agree that all agreements, notices, authorizations, disclosures and other communications that we provide to you electronically, as well as any acceptances, consents or authorizations that you provide to us electronically, satisfy any and all legal requirements that such communications be in writing.
<h2>Violations</h2>
<p>We reserve the right to monitor all uses of our Platform Services, and investigate any activity we suspect violates these Terms, your Membership Agreement, our rights or interests, or the rights or interests of any person or entity. We reserve the right, to the fullest extent permitted by law, to cooperate with any governmental authority or third-party investigating conduct that may be illegal or harm any individual or entity or violates their respective rights.
<h2>Termination</h2>
<p>You agree and acknowledge that we may suspend or terminate your authorization to access any of our Platform Services, with or without notice or cause, for any or no reason, and without any liability to you.
<h2>Healthcare Services</h2>
<p>All of the Telehealth Providers who deliver Medical Services through the Site are independent professionals solely responsible for the Medical Services each performs for Registered Users. CirrusMED is not directly engaged in the practice medicine or any other licensed profession and does not interfere with the practice of medicine or any other licensed profession by Telehealth Providers, each of whom is responsible for his or her Medical Services and compliance with the requirements applicable to his or her profession and license. Neither CirrusMED nor any third-parties who promote the Services or provide you with a link to the Services shall be liable for any professional advice you obtain from a treating Telehealth Provider via the Platform Services.
<h2>Physicians, Consultants, and Other Professionals</h2>
<p>Our Platform Services may include listings and directories to help you find Telehealth Providers that participate in our Platform Services. Such information is provided for your convenience only and shall not constitute a recommendation or endorsement of any Telehealth Provider. Telehealth Provider lists and directories are not comprehensive but represent Telehealth Providers who have chosen to participate in the Platform Services. Before obtaining Medical Services or treatment from any Telehealth Provider listed in a directory, you should take the same care you would under any other circumstance, including by confirming licensure and specialty certifications. You should confirm such information before obtaining services or treatment from any Telehealth Providers. As a convenience, the Platform Services may permit you to request an appointment with a Telehealth Provider. However, Telehealth Providers are responsible for maintaining their own schedules, and we cannot ensure that any given Telehealth Provider will be available, nor that such Telehealth Provider will not cancel his or her appointment.
<h2>Advertisements</h2>
<p>Our Services may include advertisements or promotional messages sponsored by third parties (collectively, “Ads”). The manufacturers, services providers, distributors and resellers of the products and services identified in the Ads are solely responsible for the accuracy of their Ads and the suitability, efficacy, safety and quality of such products or services. An Ad does not in any way constitute or imply our recommendation or endorsement of such product or service.
<h2>Links to Other Sites</h2>
<p>Our Platform Services may contain hyperlinks (including hyperlinked Ads) to websites operated by third-parties, or to materials or information made available by third-parties. Such links do not constitute or imply our endorsement of such third-parties, or of the content of their sites, or the suitability, efficacy, safety or quality of their products or services, or the information privacy or security practices of their websites.
<h2>Disclaimers and Limitations on Liability</h2>
<p>ACCESS TO OUR PLATFORM SERVICES AND THE INFORMATION AND CONTENT DISPLAYED ON THE SITE IS PROVIDED “AS IS” AND “AS AVAILABLE” AND WE HEREBY EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESSED, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT AND TITLE. WE DO NOT WARRANT THAT THE PLATFORM SERVICES WILL BE UNINTERRUPTED, ERROR FREE OR WITHOUT BREACHES OF SECURITY AND YOU AGREE THAT YOU ARE SOLELY RESPONSIBLE FOR ANY AND ALL ACTS OR OMISSIONS TAKEN OR MADE IN RELIANCE ON OUR PLATFORM SERVICES OR THE INFORMATION IN OUR PLATFORM SERVICES, INCLUDING INACCURATE OR INCOMPLETE INFORMATION. WE EXPRESSLY DISCLAIM ANY LIABILITY WITH RESPECT TO ANY INJURY CAUSED BY ANY USER, OR ANY DAMAGE SUFFERED BY ANY USER, AS A RESULT OF THE ACTIONS OR INACTIONS OF ANY OTHER USER, INCLUDING A TELEHEALTH PROVIDER. IF YOU ARE DISSATISFIED WITH OUR PLATFORM SERVICES OR ANY CONTENT, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING AND ACCESSING OUR PLATFORM SERVICES. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF IMPLIED WARRANTIES, SO IN THESE JURISDICTIONS THE ABOVE LIMITATIONS OR EXCLUSIONS MAY NOT APPLY TO THE USER.
<h2>Risks You Assume</h2>
<p>WITHOUT LIMITING ANY OF THE OTHER RISKS WE HAVE DISCLOSED TO YOU IN THESE TERMS, YOU ARE SOLELY RESPONSIBLE FOR YOUR USE OF OUR PLATFORM SERVICES, INCLUDING ANY INFORMATION YOU SUBMIT TO US AND YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT YOUR USE AND ACCESS TO OUR PLATFORM SERVICES AND THE INFORMATION AND CONTENT CONTAINED THEREIN, AND ANY SITES LINKED THROUGH OUR PLATFORM SERVICES AND ANY DATA TRANSMITTED THROUGH OUR PLATFORM SERVICES IS AT YOUR SOLE RISK. ACCORDINGLY, WE DO NOT ASSUME ANY LIABILITY TO YOU FOR OR RELATING TO ANY OF YOUR ACTIONS.
<h2>Limitation of Liability</h2>
<p>IN NO EVENT SHALL WE OR ANY OF OUR SUBSIDIARIES OR AFFILIATES, OR OUR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, REPRESENTATIVES, PARTNERS AND LICENSORS (COLLECTIVELY, THE “CIRRUS MEDICAL NETWORK ENTITIES”) BE LIABLE FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO, LOSS OF PROFITS OR REVENUES, LOSS OF USE, LOSS OF GOODWILL OR LOSS OF INFORMATION, HOWEVER CAUSED AND WHETHER BASED ON CONTRACT, WARRANTY, NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER THEORY OF LIABILITY, EVEN IF WE HAVE BEEN APPRISED OF THE POSSIBILITY OR LIKELIHOOD OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING IN THESE TERMS TO THE CONTRARY, OUR AGGREGATE LIABILITY IN RESPECT OF ANY CLAIM OR ACTION YOU MAY BRING AGAINST US OR ANY OF THE CIRRUS MEDICAL NETWORK ENTITIES, REGARDLESS OF FORM OF ACTION OR THEORY OF LIABILITY, SHALL BE LIMITED TO THE GREATER OF (1) ONE HUNDRED UNITED STATES DOLLARS (US $100), OR (2) THE AGGREGATE FEES ACTUALLY PAID BY YOU TO US FOR THE SIX (6) MONTH PERIOD PRECEDING THE EVENT FIRST GIVING RISE TO SUCH CLAIM OR ACTION. YOU ACKNOWLEDGE THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT ARE UNKNOWN OR UNSUSPECTED. ACCORDINGLY, YOU AGREE TO WAIVE THE BENEFIT OF ANY LAW THAT RESTRICTS THE ENFORCEABILITY OF SUCH WAIVERS AND, IN THE CASE OF A JURISDICTION WITH SUCH RESTRICTIONS, THAT THIS LIMITATION SHALL BE APPLIED TO THE FULLEST EXTENT PERMITTED BY LAW. NOTHING IN THESE TERMS OF USE IS INTENDED TO LIMIT ANY RIGHTS YOU MAY HAVE THAT MAY NOT BE LAWFULLY TERMINATED.
<h2>Indemnity</h2>
<p>You agree to defend, indemnify and hold CirrusMED and its affiliates, officers, directors, agents and employees harmless from and against any and all claims, losses, damages, liabilities and any other costs and expenses (including attorneys' fees) arising from or related to your: (i) use of the Site, Platform, or Platform Services, (ii) your breach of any representation or warranty contained in these Terms, or (iii) your failure to comply with, or other breach or default of or under, these Terms.
<h2>Disputes; Governing Law; Jurisdiction</h2>
<p>The interpretation of these Terms and the resolution of any disputes arising under these Terms shall be governed by the laws of the State of Nevada, without regard to the conflict of laws provisions thereof. If any action or proceeding is brought in connection with these Terms, you agree to submit to the personal jurisdiction of the state and federal courts located in Clark County, Nevada, and agree not to bring any action relating to the use of our Platform Services or to these Terms in any court in any jurisdiction other than the state or federal courts located in Clark County, Nevada. We reserve the right to commence and prosecute any legal or equitable action or proceeding before any court of competent jurisdiction to enforce these Terms or to protect our rights or the rights of any third-party rights in or to our Platform Services or any data, information or other content made available via our Platform Services. You hereby waive any right to a jury trial. You also agree that we may bring an action to enjoin any violation of these Terms without the posting of a bond or security, in addition to whatever remedies we might have at law. In any dispute between you and us where we prevail, we shall be entitled to recover our reasonable attorney fees, court costs, disbursements, and other legal expenses.
<h2>Severability</h2>
<p>If any sentence, paragraph, clause or combination of the same in these Terms is held by a court of competent jurisdiction to be unenforceable in any jurisdiction, such sentence, paragraph, clause or combination shall be unenforceable in the jurisdiction where it is so held, and the remainder of these Terms shall remain binding on the parties hereto in such jurisdiction as if such unenforceable provision had not been contained herein. The enforceability of such sentence, paragraph, clause or combination of the same in these Terms otherwise shall be unaffected and shall remain enforceable in all other jurisdictions.
<h2>No Waiver</h2>
<p>No provision of these Terms will be deemed waived by CirrusMED unless expressly waived in a writing signed by CirrusMED. No waiver by CirrusMED of any provision of these Terms shall be deemed a waiver of such provision with respect to any subsequent matter relating to such provision, and CirrusMED’s consent to any action shall not constitute a waiver of the requirement for obtaining CirrusMED’s consent respecting any subsequent action.
<h2>Privacy</h2>
<p>CirrusMed’s Privacy Policy applies to your access and use of the Site, and the terms of conditions of CirrusMED’s Privacy Policy and are made part of these Terms by this reference. Additionally, by using or accessing the Site, Platform or Platform Services, you acknowledge and agree that internet transmissions are never completely private or secure. You understand that any message or information you send to or through the Site, Platform or Platform Services, may be read or intercepted by others, even if there is a special notice that a particular transmission is encrypted.
<h2>Entire Agreement</h2>
<p>These Terms, together with your Membership Agreement, constitute the entire agreement between you and CirrusMED regarding any services accessed via our Platform Services, and supersede all previous communications, representations, or understandings, either oral or written, relating to the subject matter hereof; provided, however, (a) in the event of an express conflict between any specific provision included in these Terms and an express provision in a Membership Agreement, the provision set forth in the Membership Agreement shall prevail, and (b) these Terms shall cover all rights, obligations, terms and conditions not expressly addressed in such Membership Agreement.
<h2>Electronic Contracting</h2>
<p>Your use of our Platform Services includes the ability to enter into agreements and/or to make transactions electronically. YOU ACKNOWLEDGE THAT YOUR ELECTRONIC SUBMISSIONS CONSTITUTE YOUR AGREEMENT AND INTENT TO BE BOUND BY SUCH AGREEMENTS AND TRANSACTIONS. YOUR AGREEMENT AND INTENT TO BE BOUND BY ELECTRONIC SUBMISSIONS APPLIES TO ALL RECORDS RELATING TO ALL TRANSACTIONS YOU ENTER INTO ON THE SERVICES, INCLUDING NOTICES OF CANCELLATION, POLICIES, CONTRACTS, AND APPLICATIONS.
<h2>Assignment</h2>
<p>We may freely assign these Terms in connection with a merger, acquisition, or sale of assets, or by operation of law or otherwise.
<h2>Amendments</h2>
<p>We may update or change our Platform Services or these Terms from time to time and recommend that you review these Terms on a regular basis. You understand and agree that your continued use of our Platform Services after these Terms have been updated or changed constitutes your acceptance of the revised Terms. Without limiting the foregoing, if we make a change to these Terms that materially affects your use of the Platform Services, we may post notice or notify you via email or our Site of any such change. The most current version of the Terms shall govern and supersede all previous versions.
`,
   'privacy-policy-title': 'Privacy Policy',
   'privacy-policy-text': `<h2>Cirrus Medical Network Privacy Policy</h2>
<p>Cirrus Medical Network is committed to protecting the privacy of its users’ personal information. This Cirrus Medical Network Privacy Policy (this “Privacy Policy”) applies with respect to the information that we collect from the Cirrus Medical Network website, located at www.CirrusMedicalNetwork.com (the “Site”). Amendments to this Privacy Policy will be posted at this URL and will be effective when posted.
<p>THE SITE WILL BE COLLECTING AND TRANSMITTING PERSONAL, MEDICAL AND HEALTH-RELATED INFORMATION ABOUT YOU. BY USING THE SITE, YOU AGREE THAT WE CAN COLLECT AND USE YOUR PERSONAL AND OTHER INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY. IF YOU DO NOT AGREE, PLEASE DO NOT USE THE SITE.
<h2>HIPAA</h2>
<p>Our privacy practices are intended to comply with the Health Insurance Portability and Accountability Act (“HIPAA”). We will maintain the privacy of your Protected Health Information as required by HIPAA and the regulations promulgated thereunder. We encourage you to review our Notice of Privacy Practices, which describes how we may use and disclose your Health Information.
<h2>Information Collected</h2>
<p>Cirrus Medical Network may collect non-personally identifiable information about you in a number of ways, including tracking your activities through your IP address, type of browser and operating system used to access our Site, the date and time you access our Site, the pages you visit within our Site, or if you linked to the Site from another website, the address of that most-recently visited URL. We use this information to help us make our Site more useful to visitors, to learn about the number of visitors to our Site, and the types of technology our visitors use.
We do not collect any personally identifiable information about you unless you voluntarily submit such information to us, by, for example, filling out a questionnaire or registration form. The types of information that may be requested include your name, address, e-mail address, telephone number, billing information, and certain information about your health, such as your health information prepared by the health care provider(s) who provide services through the Site and any other information you input into the Site.
<h2>Use of Information</h2>
<p>In general, we will only use the information you provide to us for the purpose for which such information was provided. We may also use this information to deliver you information about our company or promotional material from some of our partners. Your information may also be used to contact you when necessary and may be shared with companies or providers that may want to contact you with offers consistent with your stated preferences. Users may opt-out of receiving future mailings by following the instructions set forth in the opt-out section below. Non-personal demographic and profile data is used to tailor your experience at our site, showing you content we think you might be interested in. This information may also be shared with advertisers on an aggregate non-personal basis.
If you provide us with personally identifiable information, for example, by sending an e-mail or by filling out a form and submitting it through our Site, we may use that information to respond to your message and to help us provide you with the information and services that you request. When you click the “Submit” button on any of the forms found on our Site, you are indicating your voluntary consent to use of the information you submit in accordance with this Privacy Policy or the Cirrus Medical Network User Agreement.
<h2>Use of IP Addresses</h2>
<p>We may use your IP Address to help diagnose problems with our server, and to administer our Site.
<h2>Cookies</h2>
<p>When you view our Site we might store some information on your computer. This information will be in the form of a "cookie" or similar file. Cookies are small pieces of information stored on your hard drive, not on our Site. Cookies do not spy on you or otherwise invade your privacy, and they cannot invade your hard drive and steal information. Rather, they help you navigate a website as easily as possible. We use cookies to deliver content specific to you and to prevent you from reentering all your registration data at each connection. We may sometimes use an outside advertisement server company to display ads on our Site, which may also contain cookies. The advertisement server company may collect cookies received with outside banner ads. We do not have access to information that would confirm the use of cookies by the advertisement server company. Please note that if you delete or choose not to accept cookies from us, you may not be able to use certain features of our Services.
<h2>Do Not Track</h2>
<p>We do not track our users over time and across third party websites to provide targeted advertising. As such, the Site does not respond to Do Not Track or “DNT” signals.
<h2>Sharing</h2>
<p>We may share information you submit to us with third parties under the following circumstances:
<ul><li>When you choose to share such information through our Services (for example, to transmit information to or from a healthcare provider);</li>
<li>With third party service providers that have agreed to confidentiality obligations, which may include, as applicable, business associate contract obligations;</li>
<li>When we believe in good faith that disclosure is necessary to protect your safety or the safety of others, to protect our rights, to investigate fraud, or to respond to a government request.</li>
<li>To protect our Services, the information we collect, and the rights of us, our users, and any third parties;</li>
<li>To detect, prevent, investigate, or address fraud, illegal activity, or violations of our terms and agreements;</li>
<li>In response to legal process, such as a search warrant, court order, or subpoena, or when we have a good faith belief that the law requires us to do so;</li>
<li>In connection with a potential or actual sale, merger, transfer, exchange, reorganization or other disposition (whether of assets, stock, or otherwise) of all or a portion of the business conducted by our Services. If such a transaction occurs, the acquiring company's use of your information will remain subject to this Privacy Policy, as may be subsequently amended;</li>
<li>For any other purpose described in this Privacy Policy, your User Agreement, or our Notice of Privacy Practices; or</li>
<li>When we otherwise have your permission.</li></ul>
<h2>Security</h2>
<p><ul><li>Our Site has industry standard security measures in place to protect the loss, misuse and alteration of the information under our control. While there is no such thing as "perfect security" on the Internet, we will take all reasonable steps to insure the safety of your personal information.</li></ul>
<h2>Other Websites, Links</h2>
<p><ul><li>Our Site may contain links to other websites. We are not responsible for the privacy practices or the content of such websites.</li></ul>
<h2>Opt-Out</h2>
<p><ul><li>You may opt-out of receiving communications from our partners, and from us, by sending an email to <a href='mailto:info@CirrusMedicalNetwork.com'>info@CirrusMedicalNetwork.com</a></li></ul>
<h2>Amendments</h2>
<p><ul><li>We may amend this Privacy Policy from time to time and revise the language of the Privacy Policy to reflect such changes. If we make a significant or material change in the way we use your personal information, the change will be posted thirty (30) days prior to taking effect and registered users will be notified via email.</li></ul>
<h2>Interaction with Children</h2>
<p><ul>
<li>Our Web site does not provide content to children under thirteen and does not collect personally identifiable information from these visitors. Therefore, the requirements of the Children's Online Privacy Protection Act (COPPA) are not incorporated in this privacy policy.</li>
</ul>`,
   'prescription-policy-title': 'Prescription Policy',
   'prescription-policy-text': `
    <p>Doctors providing consults for Cirrus Medical Network (CirrusMED) members offer prescriptions for a wide range of conditions within the scope of telemedicine. These include, but are not limited to, drug classes such as those listed below:
<ul>
<li>Allergies, Cold &Flu</li>
<li>Antibiotics</li>
<li>Arthritis & Pain (non-narcotic)</li>
<li>Asthma</li>
<li>Cholesterol</li>
<li>Diabetes</li>
<li>Ear Health</li>
<li>Fungal Infections</li>
<li>Gastrointestinal Health</li>
<li>Heart Health & Blood Pressure</li>
<li>Men's Health</li>
<li>Mental Health</li>
<li>Skin Conditions</li>
<li>Thyroid Conditions</li>
<li>Viruses</li>
<li>Vitamins & Nutritional Health</li>
<li>Women's Health</li>
<li>Other Medical Conditions</li></ul>
<p>It is important to note that CirrusMED is not a drug fulfillment warehouse. Patients may have their prescription medications monitored and refilled per the discretion of the individual network physician.
<p>In the event a doctor does prescribe medication, he/she will limit the supply based on state regulations.
<p><b>Maximum duration of prescriptions based on membership level:</b><ul>
<li>One-Time Consult - 30 days</li>
<li>Monthly Membership - 30 days while active (refilled month to month)</li>
<li>3-Month Membership - 90 days</li>
<li>Annual Membership - 90 days, with 3 refills</li></ul>
<p>CirrusMED physicians send prescriptions electronically to most U.S. pharmacies, including some "mail-order" pharmacies. We require a valid U.S. postal address.  Electronic prescriptions may take up to one hour arrive at your pharmacy.
Short-term prescriptions for maintenance medicines may also be obtained in cases where a member is in transition to a new doctor or traveling.

<p>Cirrus Medical Network doctors <b>DO NOT </b> issue prescriptions for <a href="http://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf" target="_blank">medicines controlled by the DEA*</a>, non-therapeutic, and/or certain other drugs which may be harmful because of their potential for abuse.  Prescriptions are not available for international consults.
<p><b>Cirrus Medical Network doctors WILL NOT prescribe the following controlled medications:</b><ul>
<li><b>ANXIETY MEDICATIONS</b>: XANAX (alprazolam), ATIVAN (lorazepam), VALIUM (diazepam), KLONIPIN (clonazepam)</li>
<li><b>PAIN MEDICATIONS</b>: NORCO / VICODIN/LORTAB (hydrocodone), PERCOCET (oxycodone), morphine, suboxone, dilaudid, tramadol, butrans, buprenorphine, fentanyl</li>
<li><b>DIET MEDICATIONS</b>: PHENTERMINE, PHENDRIMETRAZINE, QSYMIA, BELVIQ</li>
<li><b>SLEEP MEDICATIONS</b>: AMBIEN (zolpidem), LUNESTA, SONATA, BELSOMRA</li>
<li><b>ADD/ADHD MEDICATIONS</b>: ADDERRAL, RITALINE, CONCERTA, amphetamine, dexedrine</li></ul>
<p>*Here is a comprehensive list of controlled medications => <a href="http://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf" target="_blank">http://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf</a>
<p>For more information and helpful links regarding Prescriptions, <a href="https://cirrusmedicalnetwork.com/helpful-information-regarding-prescriptions-and-medicines-save-money/" target="_blank">click here</a>.
`,
   'our-doctors-title': 'Our Doctors',
   'our-doctors-text': `<p>Only board-certified physicians with active U.S. State licenses make up the network of physicians.  Many have traditional practices, or have been in office based practices. An introductory visit will ensure your confidence in choosing your online primary care physician. The "get to know you" visit can be via email/messaging, video conferencing, or phone. Again, each doctor is limited to 400 patients in their online practice.
Cirrus Medical Network (CMN) doctors are U.S. board-certified in internal medicine, pediatrics, and family medicine. CMN doctors are credentialed every 3 years, with NCQA certified provider credentialing standards.
They are doctors just like your primary care physician (PCP). They incorporate online health into their medical practice because they see it as a way to give more affordable, more convenient access to quality care. What doctor wouldn't love that?`,
   'you-doctor-title': 'Your Doctor. Your Time.',
   'you-doctor-text': `<p>Are you a DIY kind of person? You know, something in your house is not working, so you look it up on YouTube and research the internet for an step-by-step solution.
    If you’re lucky, the process doesn't take up too much of your valuable time. However, sorting through the myriad blog posts, forums, videos and ehow’s can seem overwhelming for some situations.
    How about that nagging medical issue? No doubt, most folks hop online to find an answer to their medical question. How can you trust the search engines results these days?
    After all, internet and affiliate marketers are hard at work constantly gaming the system to get their landing pages for all those popular medical and health keywords on page one of search results. Seems like the majority of  the time, those landing pages lead one to some sort of supplement, vitamin, or informational product.
    Savvy internet searchers know how to dismiss these affiliate sites and stick with the big names (WebMD, Medscape, and the like). Nonetheless, I’d venture that most folks spend a significant amount of their time bouncing around these supposed authority sites, only to come away more confused.`,
   'go-top-label': 'Go top',
   'your-consultation-note': 'Your consultation',
   'recieve-payment-note': 'Receive Payment',
   'bank-account': 'Bank account',
   'bank-routing-number': 'Bank routing number',
   'bank-details': 'Bank details',
   'health-profile': 'Health profile',
   ...faq,
   important: 'Important',
   'cirrusmed-disclaimer-text': 'Cirrus Medical Network is currently only hiring U.S. based and licensed physicians in the following specialties: Family Practice, Internal Medicine, and Med/Peds',
   'contact-info': `
    Cirrus Medical Network, LLC<br/>
    <br/>
10627 Professional Circle, Ste. A<br/>
Reno, NV 89511<br/>
<br/>
Voice #: <a href="tel:7026909711">702-690-9711</a><br/>
Fax #: <a href="tel:8887761880">888-776-1880</a><br/>
Text(SMS)#: <a href="tel:7026099711">702-690-9711</a><br/>`,
   'conditions-treated': 'Conditions treated',
   'conditions-treated-text': `
    <p>
Cirrus Medical Network (CirrusMED) provides online, all-inclusive, 24/7 medical care to its members via a network of board-certified physicians. Upwards of 90% of chronic and acute medical conditions typically seen in the primary care setting can be managed online.

<h3>
CirrusMED physicians may manage the following conditions within the scope of primary care telemedicine:
</h3>
    `,
   'conditions-treated-items-col-1': [
      {
         header: 'Head, Eyes, Ears, Nose, Throat',
         items: [
            'Allergies',
            'Sinus Infection',
            'Earache',
            'Toothache (no narcotic pain meds)',
            'Pink Eye / Conjunctivitis',
            'Sore Throat / Strep Throat',
            'Tonsillitis',
            'Upper Respiratory Infection / “Colds”',
         ],
      },
      {
         header: 'Lungs/ Chest',
         items: [
            'Cough',
            'Bronchitis',
            'Shortness of Breath',
            'Asthma',
            'Emphysema / COPD',
            '“walking” Pneumonia',
         ],
      },
      {
         header: 'Heart / Cardiac / Vascular',
         items: [
            'High Blood Pressure (Hypertension)',
            'High Cholesterol (Hyperlipidemia)',
            'Palpitations',
            'Chest Pain (limited to non-urgent, triage only)',
            'Congestive Heart Failure (CHF)',
            'Swelling (Edema)',
         ],
      },
      {
         header: 'Abdomen / Stomach / Gastrointestinal',
         items: [
            'Abdominal Pain (limited exam)',
            'Acid Reflux (GERD) and Heartburn',
            'Diarrhea',
            'Constipation',
            'Irritable Bowel Syndrome',
            'Nausea and Vomiting',
         ],
      },
      {
         header: 'Pediatrics',
         items: [
            'General Pediatric and Newborn Concerns (no immunizations)',
            'Colic',
            'Croup',
            'Cough',
            'Earache',
            'Rashes',
            'Fever',
            'and more…',
         ],
      },
      {
         header: 'Wellness / Prevention / Lifestyle',
         items: [
            'Routine Physical Labs',
            'Routine Screening Tests',
            'Review Wellness Needs',
            'Review Immunizations',
            'Weight Loss',
            'Optimize Health',
         ],
      },
   ],
   'conditions-treated-items-col-2': [
      {
         header: 'Infectious Disease',
         items: [
            'STD testing (via bloodwork and urine testing only)',
            'Skin infections - Cellulitis, Folliculitis, minor Boils and Abscess',
            'Fever',
            'Herpes Simplex',
            'Shingles',
            'Travel Medicine (motion sickness / antibiotics)',
         ],
      },
      {
         header: 'Dermatology',
         items: [
            'Rashes',
            'Allergic Reaction and Hives',
            'Skin Lesions',
            'Cold Sores / Fever Blisters',
         ],
      },
      {
         header: 'Psychology / Mental Health /  Addiction',
         items: [
            'Anxiety',
            'Depression',
            'Stress',
            'Insomnia',
            'Smoking Cessation',
            'Alcohol and Drug Abuse',
         ],
      },
      {
         header: 'Endocrine',
         items: [
            'Thyroid Disorders - Hyperthyroidism / Hypothyroidism',
            'Diabetes Type 2',
            'Parathyroid',
            'Adrenal',
            'Obesity',
         ],
      },
      {
         header: 'Musculoskeletal / Orthopedic/ Rheumatology',
         items: [
            'Arthritis',
            'Limited General Orthopedic (knee, shoulder, neck and back pain)',
            'Tennis Elbow',
            'Carpal Tunnel Syndrome',
            'Gout',
         ],
      },
      {
         header: 'Neurology',
         items: [
            'Migraines',
            'Headaches',
            'Neuropathy',
         ],
      },
      {
         header: 'Other',
         items: [
            'General Family Practice',
            'General Internal Medicine',
            'General Pediatrics',
            'General Adolescent Medicine',
         ],
      },
      {
         header: 'Men\'s Health',
         items: [
            'Erectile Dysfunction',
            'Viagra (sildenafil), Cialis (tadalafil)',
            'Trimix',
            'Premature Ejaculation',
            'Hair Loss',
            'Physician Grade Supplements',
            'Prostate Enlargement and Bladder Issues',
         ],
      },
   ],
   'cirrusMed/medicalFileFolders/Labs/label': 'Labs',
   'cirrusMed/medicalFileFolders/Imaging/label': 'Imaging',
   'cirrusMed/medicalFileFolders/Consults/label': 'Consults',
   'cirrusMed/medicalFileFolders/PatientUploaded/label': 'Patient Uploaded',
   'cirrusMed/medicalFileFolders/OutsideMedicalRecords/label': 'Outside Medical Records',
   'cirrusMed/medicalFileFolders/Misc/label': 'Misc.',

   'cirrusMed/medicalFileFolders/Labs/topLabel': 'Lab files',
   'cirrusMed/medicalFileFolders/Imaging/topLabel': 'Imaging files',
   'cirrusMed/medicalFileFolders/Consults/topLabel': 'Files from consults',
   'cirrusMed/medicalFileFolders/PatientUploaded/topLabel': 'Files from the patient',
   'cirrusMed/medicalFileFolders/OutsideMedicalRecords/topLabel': 'Medical records from outside',
   'cirrusMed/medicalFileFolders/Misc/topLabel': 'Miscellaneous',

   'cirrusMed/settingsSections/NOTIFICATIONS/label': 'Notifications',
   'cirrusMed/settingsSections/NOTE_TYPES/label': 'Note types',
   'cirrusMed/settingsSections/SERVICES/label': 'Services',
   'cirrusMed/settingsSections/MEMBERSHIPS/label': 'Memberships',
   'cirrusMed/settingsSections/MACROS/label': 'Macros',
   'cirrusMed/settingsSections/MANAGE_VMAS/label': 'Manage VMAs',
   'cirrusMed/settingsSections/ACCOUNT_SETTINGS/label': 'Account settings',
   'cirrusMed/settingsSections/CONSULTATIONS/label': 'Consultations',
   'cirrusMed/settingsSections/BALANCE/label': 'Balance',


   'medical-files-no-files': 'No files in this folder... Yet.',
   'medical-files-move-button': 'Move',
   'medical-files-move-title': 'Move file to a different folder',
   'medical-files-rename-button': 'Rename',
   'medical-files-rename-title': 'Rename file',
   'medical-files-confirm-delete-text': 'Are you sure you want to delete this file?',
   'medical-files-confirm-delete-title': 'Confirm deletion',
   'medical-files-add-file': 'Add file',
   'upload-medical-files-title': 'Upload new medical files',

   'documents-share-new-name': 'New filename (leave this field empty to keep the current one)',
   'documents-share-new-folder': 'Folder',
   'documents-share-select-folder-prompt': 'You can change the filename and folder before sharing the file.',
   'documents-share-select-folder-title': 'Select Folder',

   'intake-form-settings-title': 'Consultation intake form customization',
   'intake-form-settings-vitals-title': 'Vitals Settings',
   'intake-form-settings-additional-fields-title': 'Additional fields',
   'intake-form-settings-fields': 'Fields',
   'intake-form-settings-enable': 'Enable',
   'intake-form-settings-enable-vitals': 'Enable',
   'intake-form-settings-require-vitals': 'Require',
   'intake-form-settings-disable': 'Disable',
   'intake-form-settings-update': 'Update',
   'intake-form-settings-reset': 'Reset changes',
   'intake-form-settings-add-field': 'Add new field',
   'intake-form-settings-disabled': 'Disabled',
   'intake-form-settings-save': 'Save',
   'intake-form-settings-edit': 'Edit existing field',
   'intake-form-settings-vitals-require-tooltip': 'If you set "Require", at least one of Vitals fields will be required to be filled out by patients.',
   'intake-form-settings-vitals-enable-tooltip': 'If you set "Enable", patients will be able to fill out their vitals while booking an appointment using the intake form.',
   'intake-form-settings-successfully-updated': 'Successfully updated settings.',
   'intake-form-settings-reset-message': 'Settings have been reset to previous values loaded from the server.',
   'intake-form-settings-confirm-delete-field-message': 'Are you sure you want to delete this field?',

   'intake-form-cant-fill-prompt': 'Seems like this doctor doesn\'t has an intake form set up or have decided to disable it.',
   'intake-form-cant-fill-click-below': 'Click the button below to book the consultation.',
   'intake-form-cant-fill-book-button': 'Book',
   'intake-form-no-intake-form': 'No intake form was filled in.',
   'intake-form-book-button': 'Submit intake form and book',
   'intake-form-other-fields': 'Other questions',
   'intake-form-dialog-title': 'Intake form',

   'dynamic-fields-input-type': 'Type of input',
   'dynamic-fields-is-required': 'This field is required!',
   'dynamic-fields-no-question': 'No question was provided.',
   'dynamic-fields-question-required': 'Field \'Question\' is required!',

   'stripe-connect-label': 'Connect',
   'stripe-connect-title': 'Connect your account to Stripe',
   'stripe-inactive-title': 'Your Stripe account is inactive',
   'stripe-we-use-stripe-message': `We use Stripe to make sure you get paid on
 time and to keep your personal bank and
 details secure`,

   'cant-approve-dialog-title': 'Info',
   'cant-approve-dialog-inner-text': `This account can't be approved
because it has no Stripe account connected.`,
   'cant-approve-dialog-button-label': 'Got it',

   'balance-settings-available-balance': 'Available balance',
   'balance-settings-not-available': 'N/A',
   'balance-settings-funds-on-hold': 'Funds on hold',
   'balance-settings-request-payout-button-label': 'Request',
   'balance-settings-request-payout-header-title': 'Request payout',
   'balance-settings-request-payout-field-placeholder': 'Amount',
   'balance-settings-stripe-account-link-text': 'Stripe account',
   'balance-settings-stripe-payouts-link-text': 'Stripe payouts',
   'balance-settings-no-stripe-account': 'You have no Stripe account.',
   'balance-settings-unknown-error': 'There was an unknown error when loading your account info.',

   'stripe-connected-page-error-dialog-title': 'Error',
   'stripe-connected-page-error-dialog-text': 'There was an error connecting your stripe account!',
   'success-booked-title': 'Appointment request',
   'success-booked-text': 'Your request has been submitted. You will be notified upon confirmation of the appointment by your doctor.',
   'stripe-connected-page-retry-button-label': 'Retry',
   'stripe-connected-page-success-dialog-title': 'Success',
   'stripe-connected-page-success-dialog-text': 'Your stripe account is successfully connected!',
   'stripe-connected-page-go-to-settings-button-label': 'Go to settings',
   'not-active-stripe-account-error': 'Sorry, you cannot subscribe to the doctor. Please contact support service.',
   'set-commission-button-label': 'Set commission',
   'set-commission-dialog-ok-button-label': 'Set',
   'commission': 'Commission',
   'approve-application': 'Approve application?',
   'set-commission-dialog-title': 'Set commission',
   'membershipOption-not-found': 'No such membership option!',
   'doctor-not-found': 'No such doctor',
   'service-not-found': 'No such service!',
   'specialities-surgery': 'Specialities - Surgery',
   'primary-care': 'Primary Care',
   'specialities-medicine': 'Specialitites - Medicine',

   'service-settings-non-members-category': 'Non-members',
   'service-settings-members-category': 'Members',
   'service-settings-category-header-label': 'For: ',
   'service-settings-price-initial-header-label': 'Price: ',
   'service-settings-membership-duration-header-label': 'Includes: ',
   'service-settings-consecutive-price-label': 'Consecutive: ',
   'service-settings-membership-duration-tail': 'of membership',
   'service-settings-initial-price-label': 'Initial: ',

   'settings-deactivated-by-admin': 'Deactivated by admin',
   'please-buy-membership': 'Please, buy membership',
   'in-order-to-start-conversation': 'In order to start a conversation with the doctor, you need to buy a doctor\'s membership or service that provides a membership.',
   'membership-settings-trial-label': 'Trial: ',
   'membership-settings-trial-days': ' days',
   'membership-settings-title': 'Memberships',
   'family-practice': 'Family Medicine',
   'internal-medicine': 'Internal Medicine',
   'pediatrics': 'Pediatrics',
   'med-peds': 'Med/Peds',
   'ob-gyn-female': 'OB/GYN (female only)',
   'emergency-medicine': 'Emergency Medicine',

   'allergy': 'Allergy',
   'cardiology-electrophysiology': 'Cardiology - Electrophysiology',
   'cardiology-interventional-cardiology': 'Cardiology - Interventional Cardiology',
   'dermatology': 'Dermatology',
   'endocrinology': 'Endocrinology',
   'gastroenterology': 'Gastroenterology',
   'geriatrics': 'Geriatrics',
   'hematology-oncology': 'Hematology/Oncology',
   'hospitalist': 'Hospitalist',
   'infectious-disease': 'Infectious Disease',
   'interventional-radiology': 'Interventional Radiology',
   'medical-genetics': 'Medical Genetics',
   'nephrology': 'Nephrology',
   'neuroradiology': 'Neuroradiology',
   'neurology': 'Neurology',
   'nuclear-medicine': 'Nuclear Medicine',
   'occupational-medicine': 'Occupational Medicine',
   'pain-management': 'Pain Management',
   'palliative-care': 'Palliative Care',
   'pathology': 'Pathology',
   'psychiatry': 'Psychiatry',
   'pulmonary-medicine': 'Pulmonary Medicine',
   'radiation-oncology': 'Radiation Oncology',
   'radiology': 'Radiology',
   'rheumatology': 'Rheumatology',
   'wound-care': 'Wound Care',
   'adolescent-medicine': 'Adolescent Medicine (age 11-21)',
   'subscriptionExpires': 'Membership Expires',
   'serviceBought': 'Service Bought',

   'cardiovascular-surgery': 'Cardiovascular Surgery',
   'general-surgery-colorectal-surgery': 'General Surgery - Colorectal Surgery',
   'general-surgery-thoracic-surgery': 'General Surgery - Thoracic Surgery',
   'general-surgery-pediatric-surgery': 'General Surgery - Pediatric Surgery',
   'general-surgery-surgical-oncology': 'General Surgery - Surgical Oncology',
   'general-surgery-vascular-surgery': 'General Surgery - Vascular Surgery',
   'general-surgery-transplant-surgery': 'General Surgery - Transplant Surgery',
   'gynecologic-oncology': 'Gynecologic Oncology',
   'neurosurgery': 'Neurosurgery',
   'ophthalmology': 'Ophthalmology',
   'oral-surgery': 'Oral Surgery',
   'orthopedics': 'Orthopedics',
   'otolaryngology-head-neck-surgery': 'Otolaryngology / Head & Neck Surgery (ENT)',
   'plastic-reconstructive-surgery': 'Plastic & Reconstructive Surgery',
   'podiatric-surgery-podiatry': 'Podiatric Surgery / Podiatry',
   'choose-fields-to-report': 'Please choose fields which will be shown in the report',
   'urology': 'Urology',
   'fill-report-below': 'Please fill out the report form below.',
   'download-report': 'Download report',
   'cltv-tooltip': 'Customer Life Time Value',
   'age-period-empty': 'Cannot add empty age period',
   'age-period-not-integer': 'Age must be a whole number',
   'gender': 'Gender',
   'age': 'Age',
   'subscriptionStatus': 'Membership Status',
   'subscriptionName': 'Membership Name',
   'subscriptionBought': 'Membership Bought',
   'subscriptionDoctor': 'Membership Doctor',
   'serviceName': 'Service Name',
   'serviceDoctor': 'Service Doctor',
   'vmas': 'VMAs',
   'cltvGrossProfit': 'CLTV Gross Profit',
   'how-it-works-first-title': 'When you need more than 15 minutes',
   'how-it-works-first-text': `
   If you've ever felt rushed through a doctor's visit, then you know the feeling. Pressured to explain your story, your symptoms, fast.  And we all know, no one likes pressure.
   <br/>
   <br/>
   Your health is worth much more than a cursory 10-15 minute visit.
   <br/>
   <br/>
   Relax, our doctors are here to listen now, and in the future. With direct access, you may easily follow-up by messaging your doctor at any time. Or, make another appointment online for real-time discussion. Even better, you won't have to explain your story again, and again, because you retain the same doctor as long as you want.
   `,
   'how-it-works-second-title': 'ALL-IN-ONE Telehealth Care',
   'how-it-works-second-text': `
   Our platform is accessible through any browser and from any device. No need to download an app or create a separate account with Zoom, Skype, or Facetime.  Just go to CirrusMED.com and everything is in one place.
   <ul>
   <li>Easily upload, share, view medical reports and documents between you and your doctor.</li>
   <br/>
   <li>Video chat or upload a photo as needed</li>
   <br/>
   <li>Message your doctor and/or the doctor's virtual medical assistant easily</li>
   <br/>
   <li>Request prescription refills, labs, imaging, referral and other services with just a few clicks</li>
   </ul>
   `,
   'features': 'Features',
   'features-label': 'While personalized care is our specialty, we make it easier by leveraging technology.',
   'video-chat-card-text': `
   Do not jeopardize your privacy and personal health information by using non-secure apps like Zoom, Skype and Facetime.
   <br/>
   <br/>
Our internal video chat is HIPPA-compliant and accessible from any device/browser. Just book your appointment online and "enter" the video chat at the time of your appointment right from CirrusMED.com
   `,
   'direct-message-card-title': 'Direct message / text your doctor',
   'direct-message-card-text': `
   Texting is pretty much second nature for most. Choose asynchronous messaging for those quick updates or routine medical questions. Or live chat (synchronous messaging) during an appointment so that you get undivided attention from your doctor and instant answers.
<br/>
<br/>
Have a photo or document you'd like to share with your doctor? Simply attach it to your message.
<br/>
<br/>
Customize your notifications by choosing email, SMS/Text, and/or website notifications.
   `,
   'share-view-card-title': 'Share & view documents',
   'share-view-card-text': 'Easily upload, share, and view medical reports and documents. Our unique "shared folder" allows you and your doctor to collaborate on your care. Medical care is no longer one-sided. It is a joint venture -- between you and your provider. ',
   'services-card-title': 'Services',
   'services-card-text': `
   Choose from one of our "one-time" services:
   <br/>
   <br/>
   <ul>
   <li>One-time consultation:</li>
   <br/>
   <li>New Prescription Request</li>
   <br/>
<li>Prescription Refill Request</li>
<br/>
<li>MRI / Diagnostic Imaging Request</li>
<br/>
<li>...and more</li>
`,
   'membership-card-title': 'Memberships',
   'membership-card-text': `
As a member, you benefit from direct access to your physician as often as you need to for as long as you are a member.
<br/>
<br/>
…a doctor’s practice model that works like “Netflix for Medicine”.  You subscribe to your local doctor’s practice for a monthly fee and binge on health care when you need it!
<br/>
<br/>
The doctor/patient relationship as it should be.
`,
   'direct-imaging-card-title': 'Direct imaging',
   'direct-imaging-card-text': 'Need an MRI or X-Ray order, but stuck in the crazy healthcare system? Bypass the hassles and sign up for our direct imaging referral service. ',
   ...privacyPolicy,
};



// WEBPACK FOOTER //
// ./src/sources/locale/en.js